import {
  Document,
  Page,
  StyleSheet,
  Text,
  View,
  Font,
} from "@react-pdf/renderer";
import { formatDateDDMMYYYY } from "../../../../helpers/functions/dateFormatter";

const formatLegalDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  const day = date.getDate();
  const year = date.getFullYear();
  const month = date.toLocaleString("default", { month: "long" });

  const getOrdinal = (n) => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const ordinal = getOrdinal(day);

  return { day, ordinal, month, year };
};

function splitLongWords(text, maxLength) {
  const textInString = text?.toString();
  const words = textInString?.split(" ");
  const newWords = words?.map((word) => {
    if (word.length > maxLength) {
      let parts = [];
      for (let i = 0; i < word.length; i += maxLength) {
        parts.push(word.substring(i, i + maxLength));
      }
      return parts.join("\n");
    }
    return word;
  });
  return newWords?.join(" ");
}

// part: "mtbl" = MT-BL Agreement only, "consent" = Aadhar Consent page(s) only,
// "all" = both, as one document (the older combined upload).
const AadharConcentandMTBLAggrementDocumentPDF = ({ formData, part = "all" }) => {
  Font.registerHyphenationCallback((word) => {
    if (word.length > 12) {
      return word.split("");
    }
    return [word];
  });

  const styles = StyleSheet.create({
    page: {
      fontSize: 11,
      padding: 50,
      fontFamily: "Times-Roman",
      paddingTop: 40,
      paddingBottom: 100,
      paddingHorizontal: 40,
      lineHeight: 1.2,
      minHeight: "100vh",
    },
    heading: {
      color: "black",
      fontWeight: "bold",
      fontSize: 12,
      textDecoration: "underline",
      textAlign: "center",
      fontFamily: "Times-Bold",
    },
    title: {
      fontSize: 12,
      fontWeight: "bolder",
      textAlign: "center",
      marginBottom: 20,
    },
    paragraph: {
      fontSize: 11,
      marginBottom: 10,
      textAlign: "justify",
    },
    footer: {
      position: "absolute",
      bottom: 30,
      left: 40,
      right: 40,
      fontSize: 8,
      textAlign: "center",
    },
    footerBold: {
      fontWeight: "heavy",
      fontFamily: "Times-Roman",
      fontSize: 10,
    },
    bold: {
      fontWeight: "bold",
      fontSize: 12,
      fontFamily: "Times-Bold",
    },
    pageNumber: {
      textAlign: "right",
      fontSize: 10,
    },
    underline: {
      textDecoration: "underline",
    },
    indent: {
      marginLeft: 15,
    },
    table: {
      display: "table",
      width: "100%",
      borderWidth: 1,
      borderColor: "#000",
    },
    tableRow: {
      display: "flex",
      flexDirection: "row",
    },
    tableCol: {
      border: "1px solid black",
      padding: "5px",
      boxSizing: "border-box",
      flexShrink: 1,
      flexGrow: 0,
    },
    tableCell: {
      fontSize: "10px",
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      overflowWrap: "break-word",
      flexWrap: "wrap",
    },
  });

  const rawDate = formData?.date || "";
  const { day, ordinal, month, year } = formatLegalDate(rawDate);
  const newDateFormate = `${day}${ordinal} ${month} ${year}`;

  function formatCurrencyText(input) {
    return input
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize each word
      .replace(/\bLakh\b/, "Lakhs"); // Optionally convert "Lakh" to "Lakhs"
  }

  const formattedValue = formatCurrencyText(formData?.amount_in_word);

  const formattedAmount = formData.creditLimit.toLocaleString("en-IN");


  const currentDate = new Date();
  const formatedTodaysDate =
    rawDate !== ""
      ? formatDateDDMMYYYY(rawDate)
      : formatDateDDMMYYYY(currentDate);
  const furmName = formData?.companyName;
  const firmAddress = formData?.address;
  const firmRepresentative = formData?.personName;
  const PAN = formData?.pan_no;
  const age = formData?.age;
  const FathersName = formData?.fathersName;
  const CreditLimitInValue = formattedAmount;
  const CreditLimitInWord = formattedValue;
  const columnWidths = ["5%", "20%", "75%"];
  const columnWidthsss = ["5%", "20%", "15%", "15%", "15%", "15%", "15%"];
  const columnWidthss = ["70%", "30%"];
  const columnWidthssss = ["50%", "50%"];
  const columnWidth = ["33%", "34%", "33%"];
  const columnWidthNoticeClause = ["30%", "70%"];
  const bankName = formData?.bank_name;
  const AccountNo = formData?.account_no;
  const accountName = formData?.account_name;
  const cheque_1 = formData?.cheque_number;
  const cheque_2 = formData?.cheque_number_2;
  const Branch = formData?.branch;
  const IFSC = formData?.ifsc;
  const EffectiveDate = newDateFormate;
  const Email = formData?.email;
  const CIN = formData?.cin;
  const KSOSID = formData?.otherDetails?.dealerId || "";
  const heading =
    "APPLICATION FOR LOAN ACCOUNT OPENING USING AADHAAR E-KYC FOR CUSTOMERS";

  const companyName = formData?.companyName || "";

  const name = formData?.name || "";
  const isTAFundingByMt = formData?.is_ta_funding_by_mt;

  const facilityLetter = {
    headers: ["Sr No.", "Particulars ", "Provisions "],
    rows: [
      [
        "1",
        "Channel Partner",
        formData?.businessType === "individual"
          ? `Mr./Ms. ${formData?.name ? formData?.name : formData?.personName} (Income Tax Permanent Account Number ${PAN?.toUpperCase()}), aged ${age} years, son of / wife of / daughter of ${FathersName}, being an Indian Resident, presently residing at ${firmAddress}.`
          : formData?.businessType === "proprietor"
            ? `${furmName} being a sole proprietor firm, having its principal place of business ${firmAddress}, owned and managed by its sole proprietor being Mr. ${name} (Income Tax Permanent Account Number ${PAN}), aged ${age} years, son of ${FathersName}.`
            : formData?.businessType === "partnership"
              ? `${furmName}, a partnership firm within the meaning of the Partnership Act, 1932, having its principal place of business at ${firmAddress} and having Income Tax Permanent Account Number ${PAN}, acting through its partners: ${formData?.otherDetails?.partnerDetails?.join(" and ")}`
              : formData?.businessType === "pvt_ltd"
                ? `${furmName} (Corporate Identity Number ${CIN} and Income Tax Permanent Account Number ${PAN}), a company within the meaning of the Companies Act, 2013, having its registered office at ${firmAddress}`
                : "",
      ],
      [
        2,
        "Loan Facility",
        `The Facility shall be in the form of a revolving credit line up to maximum of amount of INR 25,00,000/- (Rupees Twenty-Five Lacs only) (“Facility Amount”), and shall be available for drawdown by the Channel Partner. All amounts repaid by the Channel Partner shall be available for drawdown, subject to a maximum of the facility Amount. 

Channel Partner will only be able to drawdown INR ${CreditLimitInValue} (${CreditLimitInWord}) at the start and adhoc limit of ${isTAFundingByMt ? "10,00,000 (Ten Lakhs Rupees Only)" : "INR 15,00,000/- (Rupees Fifteen Lacs only)"} can be activated upon approval/recommendation by KSOS`,
      ],
      [
        3,
        "End Use (Purpose)",
        "The Facility amount shall be utilized for purchase of used vehicle from Platform. ",
      ],
      [
        4,
        "Interest Rate and Processing Fees ",
        `Interest Rate As per Credit Request Letter
         Processing Fees - As per Credit Request Letter `,
      ],
      [
        5,
        "Tenor",
        `The agreement has a validity of 60 Months.

Each tranche Tenor is 60 days from the date of disbursement
 `,
      ],
      [
        6,
        "Overdue Interest Amount",
        `Additional Interest would be levied at the rate of 36% per annum, over and above the Interest rate, compounded monthly, shall be payable in case of any delay or default in payment of any monies payable to KSOS and Finance Companies, post 60 days from the date of disbursement. Additional Interest shall be payable on the delayed amounts, from 61st day from the date of disbursement`,
      ],
      [
        7,
        "Back-out Fees",
        `Non-refundable Back-out Fees of INR 20,000/- (Rupees Twenty Thousand only) plus applicable taxes would be levied if Channel Partner is unable to repay the Outstanding Amount before 60 days from the date of disbursement `,
      ],
      [
        8,
        "Loss on sale of asset",
        `Loss on sale of asset would be borne by the Channel Partner 

Loss on sale of asset – difference in price at which the vehicle was bought from the Platform and sold to other buyer in cases where Channel Partner is unable to repay the Outstanding Amount before 60 days from the date of disbursement
`,
      ],
      [
        9,
        "Day count basis",
        `All Outstanding Amounts, charges and other amounts payable in relation to the Facility shall accrue from day to day and shall be computed on the basis of a 365 (Three Hundred and Sixty-Five) day year for the actual number of days elapsed. `,
      ],
      [
        10,
        "Outstanding Amounts",
        `All amounts payable by the Channel Partner to KSOS and Finance Companies in relation to the Facility will follow waterfall mechanism as per below mentioned priority order:
Finance Companies Processing Fees 
Finance Companies Overdue Interest Amount
Finance Companies Interest Amount
Finance Companies Principal Amount 
KSOS Back-out Fees 
Loss on sale of asset incurred to KSOS
and all other fees, charges, costs, expenses, indemnities, interest and penalties, incurred under, arising out of or in connection with Facility, and in relation to collection of the outstanding amounts. 
`,
      ],
      [
        11,
        "Event of Default",
        `The following events shall be deemed to be events of default if the Channel Partner fails to repay Outstanding Amount on or before 60 days from the date of disbursement `,
      ],
    ],
  };

  const postDatedCheque = {
    headers: [
      "Sr No.",
      "Account Name ",
      "Bank Name ",
      "Bank Location",
      "Cheque No",
      "IFSC Code",
      "Account No",
    ],
    rows: [
      [
        "1",
        `${accountName || ""}`,
        `${bankName}`,
        `${Branch}`,
        `${cheque_1}`,
        `${IFSC}`,
        `${AccountNo}`,
      ],
      [
        "2",
        `${accountName || ""}`,
        `${bankName}`,
        `${Branch}`,
        `${cheque_2}`,
        `${IFSC}`,
        `${AccountNo}`,
      ],
    ],
  };

  const GeneralDetails = {
    headers: ["Sr No.", "Terms", "Particulars / Details"],
    rows: [
      [
        "1",
        "Channel Dealer(s)",
        formData?.businessType === "individual"
          ? `Mr./Ms. ${formData?.name ? formData?.name : formData?.personName} (Income Tax Permanent Account Number ${PAN?.toUpperCase()}), aged ${age} years, son of / wife of / daughter of ${FathersName}, being an Indian Resident, presently residing at ${firmAddress}.`
          : formData?.businessType === "proprietor"
            ? `${furmName} being a sole proprietor firm, having its principal place of business ${firmAddress}, owned and managed by its sole proprietor being Mr. ${name} (Income Tax Permanent Account Number ${PAN}), aged ${age} years, son of ${FathersName}.`
            : formData?.businessType === "partnership"
              ? `${furmName}, a partnership firm within the meaning of the Partnership Act, 1932, having its principal place of business at ${firmAddress} and having Income Tax Permanent Account Number ${PAN}, acting through its partners: ${formData?.otherDetails?.partnerDetails?.join(" and ")}`
              : formData?.businessType === "pvt_ltd"
                ? `${furmName} (Corporate Identity Number ${CIN} and Income Tax Permanent Account Number ${PAN}), a company within the meaning of the Companies Act, 2013, having its registered office at ${firmAddress}`
                : "",
      ],
      [2, "Effective Date", `${EffectiveDate}`],
      [3, "Place of Execution", "Pune, Maharashtra, India"],
      [4, "Jurisdiction", "Pune, Maharashtra, India"],
      [5, "Places for determining Business Day", "Pune, Maharashtra, India"],
      [
        "6",
        "Notice Clause details for the Dealer(s) and the Company",
        {
          isNested: true,
          parties: [
            {
              title: "For Channel Dealer",
              values: [
                ["Attention", formData?.businessType === "partnership" ? formData?.otherDetails?.partners?.slice(0, -1).join(", ") + " and " + formData?.otherDetails?.partners[formData?.otherDetails?.partners.length - 1] : name],
                ["Address", firmAddress],
                ["Email", Email],
              ],
            },
            {
              title: "For Krishak Sevita Online Solutions Pvt. Ltd.",
              values: [
                ["Attention", "Mr. Monak Gohel (Director)"],
                [
                  "Address",
                  "Krishak Sevita Online Solutions Pvt. Ltd, 303, Building B, Kumar Gulmohar, Near Nancy Gardens, Wanawadi, Pune - 411040",
                ],
                ["Email", "monak@meratractor.com"],
              ],
            },
          ],
        },
      ],
    ],
  };

  const VehicleDetails = {
    rows: [
      [`Make - `, `Reg No.- `, `Engine No. - `],
      [`Model  - `, `Chassis No.- `, ""],
    ],
  };

  const DealerBankDetails = {
    rows: [
      [`Name of the bank - `, `Account No. -  `],
      [`Name of the Branch - `, `IFSC Code.- `],
    ],
  };
  const BorrowerBankDetails = {
    rows: [
      [`Name of the bank -  `, `Account No. -  `],
      [`Name of the Branch - `, `IFSC Code.- `],
    ],
  };
  const BifurcationofLoanAmount = {
    rows: [
      ["Loan amount (Sanctioned)", ""],
      ["Disbursement received from Finance", ""],
      ["Platform Fee", ""],
      ["RC transfer charges", ""],
      ["Initial RC Hold Amount", ""],
      ["RC Hold for Ageing Cases", ""],
      ["Insurance Hold Amount", ""],
      [
        "Net Payable amount",
        `Total –
        Paid to (Dealer Name)
        Paid to (Borrower Name) `,
      ],
    ],
  };
  const ShortTermCreditLoan = {
    rows: [
      ["Tenor of the Loan ", "60 Days from Date of Disbursement "],
      [
        "Interest Rate",
        "Fixed rate of Interest of 18% (Eighteen percent) per annum",
      ],
      [
        "Processing Fees",
        "Non-refundable Processing Fees payable upfront of 1% of the Facility Amount plus applicable taxes.",
      ],
      ["Finance Company", "Tyger Capital Private Limited"],
      [
        "Repayment Waterfall Mechanism ",
        "As per Channel Finance Agreement signed with KSOS ",
      ],
    ],
  };
  const LoanCalculation = {
    rows: [
      ["Total value of the asset ", "INR  ___________ /-"],
      [
        "Channel Partner Margin Money",
        "INR ____________/- (____% of the Total value of the asset)",
      ],
      ["Loan requirement", "INR ____________ /-"],
      ["Processing Fees", "INR ____________ /- (% of the Loan Amount)"],
      ["Total Loan Value", "INR ____________/-"],
    ],
  };
  const TransferLoanAmount = {
    rows: [
      ["Amount to be Transferred", "INR  ___________ /-"],
      ["Name of Beneficiary", ""],
      ["Bank Name ", ""],
      ["Account Number", ""],
      ["Branch", ""],
      ["IFSC Code", ""],
    ],
  };
  const ConformationCreditAskingTable = {
    rows: [
      ["Type of used vehicle", "Tractor / SC / LCV"],
      ["Make", ""],
      ["Chassis Number", ""],
      ["Reg Number", ""],
      ["Engine Number", ""],
      ["Mfg Year", ""],
      [
        "Total Value of the Asset",
        "INR ____________/-  (Rupees _______ Lacs only)",
      ],
    ],
  };
  const annexureAFee = {
    rows: [
      [
        "Base Rate Commission",
        "Floating Base Payout of 1.00% (the same would be communicated by KSOS through email / letter) of the total loan amount disbursed to the Leads in a month.",
      ],
      [
        "Volume Linked Incentive",
        "Incentive % (above Base Rate) of the total loan amount disbursed in a month, depending upon the amount disbursed. The same would be communicated by KSOS through email / letter.  ",
      ],
    ],
  };
  const AnnexureCKSOSBankAccountDetails = {
    rows: [
      [
        "Name of Beneficiary",
        "Krishak Sevita Online Solutions Private Limited",
      ],
      ["Bank Name", "Kotak Mahindra Bank Ltd"],
      ["Account Number", "8888009900"],
      ["Branch", "PUNE-KONDHWA"],
      ["IFSC Code", "KKBK0000724"],
    ],
  };
  const content = `I/We (Name of the Borrower) authorize you to make the payment of Rs (Net Payable Amount) /- in favor of (Name of the Dealer and Customer) against loan Sanctioned and extended via loan from (Name of the Financier) with loan account no _______________. 
I hereby confirm this loan is being utilized to make payment towards purchase price of Vehicle Registration number (Mention RC Number). From today onwards all the liabilities of Vehicle regarding Tax, Insurance, Challan and whatsoever arises in future will be mine. I am aware that this is a mandatory requirement to get the purchase price of the vehicle fixed with below details. I hereby accept the delivery of the Vehicle on an ‘as is where is, what is basis’. I further agree and confirm that KSOS and / or its employees and / or its officers and / or its representatives shall not be responsible for any liability concerning the Vehicle.
`;

  const assuranceText = `I/We assure you that the repayments of the instalment would be made by me/us to the concerned financier on or before the due date of the instalment for the subject loan to (Name of the Financier). 
(Name of the Dealer) Account Details:
`;

  console.log(formData);


  return (
    <>
      {/* <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            <Text style={styles.heading}>{heading}</Text>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "right",
              }}
            >
              <Text> </Text>
            </View>
            <Text>
              {
                isTAFundingByMt
                  ? "To, \nThe Manager\nKrishak Sevita Online Solutions Private Limited (KSOS)"
                  : "To, \nThe Branch Manage\nTyger Capital Pvt. Ltd (TCPL) (Formerly Known as Adani Capital Pvt Ltd)"
              }
            </Text>
            <Text style={{ marginTop: 10 }}>Dear Sir/Madam,</Text>
            <Text style={{ marginTop: 5 }}>
              Opening of Loan account with Tyger Capital Pvt. Ltd (TCPL) Mumbai
              Branch
            </Text>
            <Text>{contents}</Text>

            <View style={{ flexDirection: "col" }}>
              <Text>Name & Signature,</Text>
              <Text>(Applicant/Co-Applicant/Guarantor)</Text>
            </View>
          </View>
        </Page>
      </Document> */}
      <Document>
        {part !== "consent" && (
        <Page size="A4" style={styles.page}>
          <Text style={styles.title}>
            Business Alliance Agreement (“Agreement”)
          </Text>
          <Text style={[styles.paragraph, { marginLeft: 10 }]}>
            {`   This Agreement is made at Pune on this ${day}${ordinal} day of ${month}, ${year} (${day}${ordinal} ${month}, ${year}) by and between:`}
          </Text>
          <View style={{ flexDirection: "row", marginTop: 10, marginLeft: 10 }}>
            <Text style={{ width: 20 }}>{`l.`}</Text>
            <Text style={[styles.paragraph, { flex: 1 }]}>
              <Text style={styles.bold}>
                Krishak Sevita Online Solutions Private Limited
              </Text>
              {`, a company incorporated under Companies Act, 1956, having its registered office at `}
              <Text style={styles.bold}>
                303, Building B, Kumar Gulmohar, Near Nancy Gardens, Wanawadi,
                Pune, MH - 411040
              </Text>
              {` (hereinafter referred to as `}
              <Text style={styles.bold}>"KSOS"</Text>
              {`, which expression shall, unless it be repugnant to the context or meaning thereof, be deemed to include its successors and assigns) of the `}
              <Text style={styles.bold}>FIRST PARTY</Text>
              {`; and`}
            </Text>
          </View>
          <View style={{ flexDirection: "row", marginTop: 10, marginLeft: 10 }}>
            <Text style={{ width: 20 }}>{`ll.`}</Text>
            {formData?.businessType === "individual" && (
              <Text style={[styles.paragraph, { flex: 1 }]}>
                {`Mr./Ms. `}
                <Text style={styles.bold}>{formData?.name ? formData?.name : formData?.personName}</Text>
                {`, (Income Tax Permanent Account Number  `}
                <Text style={styles.bold}>{PAN?.toUpperCase()}</Text>
                {`), aged `}
                <Text style={styles.bold}>{age}</Text>
                {` years, son of / wife of / daughter of  `}
                <Text style={styles.bold}>{FathersName}</Text>
                {`being an Indian Resident, presently residing at   `}
                <Text style={styles.bold}>{firmAddress}</Text>
                {` (hereinafter referred to as “Channel Partner"", which expression shall, unless it be repugnant to the context or meaning thereof, be deemed to mean and include its successors and permitted assigns) of the `}
                <Text style={styles.bold}>SECOND PARTY</Text>
              </Text>
            )}
            {formData?.businessType === "partnership" && (
              <Text style={[styles.paragraph, { flex: 1 }]}>
                <Text style={styles.bold}>{` ${furmName}`}</Text>
                {`, a partnership firm within the meaning of the Partnership Act, 1932, having its principal place of business at `}
                <Text style={styles.bold}>{firmAddress}</Text>
                {` and having Income Tax Permanent Account Number `}

                <Text style={styles.bold}>{PAN}</Text>
                {`, acting through its partners: `}
                <Text style={styles.bold}>
                  {formData?.otherDetails?.partnerDetails?.join(" and ")}
                </Text>

                {`. (hereinafter referred to as “Channel Partner"", which expression shall, unless it be repugnant to the context or meaning thereof, be deemed to mean and include its successors and permitted assigns) of the `}
                <Text style={styles.bold}>SECOND PARTY</Text>
              </Text>
            )}
            {formData?.businessType === "proprietor" && (
              <Text style={[styles.paragraph, { flex: 1 }]}>
                <Text style={styles.bold}>{` ${furmName}`}</Text>
                {`, being a sole proprietor firm, having its principal place of business at `}
                <Text style={styles.bold}>{firmAddress}</Text>
                {`, owned and managed by its sole proprietor being Mr./Ms `}
                <Text style={styles.bold}>{`Mr. ${name}`}</Text>
                {` (Income Tax Permanent Account Number `}
                <Text style={styles.bold}>{PAN}</Text>
                {`), aged `}
                <Text style={styles.bold}>{age}</Text>
                {` years, son of `}
                <Text style={styles.bold}>{FathersName}</Text>
                {`. (hereinafter referred to as “Channel Partner"", which expression shall, unless it be repugnant to the context or meaning thereof, be deemed to mean and include its successors and permitted assigns) of the `}
                <Text style={styles.bold}>SECOND PARTY</Text>
              </Text>
            )}
            {formData?.businessType === "pvt_ltd" && (
              <Text style={[styles.paragraph, { flex: 1 }]}>
                <Text style={styles.bold}>{` ${furmName}`}</Text>
                {` (Corporate Identity Number `}
                <Text style={styles.bold}>{` ${CIN}`}</Text>
                {` and Income Tax Permanent Account Number `}
                <Text style={styles.bold}>{PAN}</Text>
                {`  a company within the meaning of the Companies Act, 2013, having its registered office at `}
                <Text style={styles.bold}>{firmAddress}</Text>

                {`. (hereinafter referred to as “Channel Partner"", which expression shall, unless it be repugnant to the context or meaning thereof, be deemed to mean and include its successors and permitted assigns) of the `}
                <Text style={styles.bold}>SECOND PARTY</Text>
              </Text>
            )}
          </View>
          {formData?.businessType === "partnership" &&
            (formData?.partnerDetails?.length > 0
              ? formData.partnerDetails.map((partner, index) => (
                  <Text key={index} style={[styles.paragraph, { flex: 1, marginLeft: 10 }]}>
                    {"Mr./Ms. "}
                    <Text style={styles.bold}>{partner.name}</Text>
                    {", (Income Tax Permanent Account Number "}
                    <Text style={styles.bold}>{partner.pan_no?.toUpperCase()}</Text>
                    {"), aged "}
                    <Text style={styles.bold}>{partner.age}</Text>
                    {" years, son of / wife of / daughter of "}
                    <Text style={styles.bold}>{partner.fathersName}</Text>
                    {" being an Indian Resident, presently residing at "}
                    <Text style={styles.bold}>{partner.address}</Text>{"."}
                  </Text>
                ))
              : (
                <Text style={[styles.paragraph, { flex: 1, marginLeft: 10 }]}>
                  {"Mr./Ms. "}
                  <Text style={styles.bold}>{formData?.name ? formData?.name : formData?.personName}</Text>
                  {", (Income Tax Permanent Account Number  "}
                  <Text style={styles.bold}>{PAN?.toUpperCase()}</Text>
                  {"), aged "}
                  <Text style={styles.bold}>{age}</Text>
                  {" years, son of / wife of / daughter of  "}
                  <Text style={styles.bold}>{FathersName}</Text>
                  {" being an Indian Resident, presently residing at   "}
                  <Text style={styles.bold}>{firmAddress}</Text>{"."}
                </Text>
              )
            )}
          <Text style={[styles.paragraph, { marginLeft: 10 }]}>
            <Text
              style={styles.bold}
            >{`“KSOS” and "${formData?.businessType === "partnership" ? furmName : name}"`}</Text>
            {` are hereinafter individually referred to as "Party" and collectively as "Parties" `}
          </Text>
          <Text style={[styles.paragraph, { marginLeft: 9 }]}>
            {` WHEREAS: `}
          </Text>
          <View style={{ flexDirection: "row", marginTop: 10, marginLeft: 10 }}>
            <Text style={{ width: 20 }}>{`A.`}</Text>
            <Text style={[styles.paragraph, { flex: 1 }]}>
              {` KSOS along with its affiliates, owns and operates several online and offline platforms, including but not limited to the auto classified portals with the name and style of www.meratractor.com, Rapibid (collectively referred to as the "Portal" or "Platform"). KSOS is inter alia engaged in providing technology enabled online and offline marketing, lead generation, vehicle warranty, and business auxiliary services to its customers. KSOS is also a direct selling agent of several Finance Companies for sourcing clients/customers for various Financial Products offered by such banks and non-banking finance companies. This definition shall include the existing and any other future online or offline platforms KOSOS may develop or acquire `}
            </Text>
          </View>
          <View style={{ flexDirection: "row", marginTop: 10, marginLeft: 10 }}>
            <Text style={{ width: 20 }}>{`B.`}</Text>
            <Text style={[styles.paragraph, { flex: 1 }]}>
              {` Channel Partner is engaged in the business of sale and purchase of new and used motor vehicles and rendering certain allied services to various customers. Channel Partner has offered to source customers desirous of availing finance for purchase of used vehicles (Tractors/SC-LCV-CV/Cars) amongst various Finance Products promoted and marketed by KSOS on behalf of various Finance Companies. Additionally, the Channel Partner may also directly avail themselves of such short-term Loan Facility, for the purchase of vehicles listed on the KSOS Platform, as specified in the Facility Letter, subject to the creditworthiness and approval criteria of these Finance Companies ("Lead/Leads" shall refer to both customers sourced by the Channel Partner and the Channel Partner’s own applications for Financial Products.).. `}
            </Text>
          </View>
          <View style={{ flexDirection: "row", marginTop: 10, marginLeft: 10 }}>
            <Text style={{ width: 20 }}>{`C.`}</Text>
            <Text style={[styles.paragraph, { flex: 1 }]}>
              {` Based on Channel Partner' representation, KSOS has decided to enter into this Agreement with Channel Partner, wherein Channel Partner will offer/source Leads to KSOS and KSOS will assist such Leads in availing Finance Products offered by Finance Companies, subject to the Lead's creditworthiness and approval criteria of Financial Companies. `}
            </Text>
          </View>
          <Text style={[styles.paragraph, { marginLeft: 10 }]}>
            <Text style={styles.bold}>NOW THEREFORE,</Text>
            {` in consideration of the mutual covenants contained herein, the Parties agree as follows: `}
          </Text>
          {/* 1. DEFINITIONS: */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`1.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {` DEFINITIONS: `}
              </Text>
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>"Agreement"</Text>
              {` shall mean this agreement including annexures, schedules any document referred herein, and shall include any modifications in writing or communicated through any electronic communication by KSOS. `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>“Credit Request Letter”</Text>
              {`  shall mean confirmation/go-ahead (duly signed by the Channel Partner) to avail Financial Product for purchasing of used vehicle sold on KSOS Platform from Finance Companies and transfer the amount to Seller as per the break-up/information provided in the letter. `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>"Effective Date"</Text>
              {` shall be the date specified in Clause 2 of Schedule 3 (General Details) hereto, being the date of execution of this Agreement. `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>"Effective Date"</Text>
              {` shall be the date specified in Clause 2 of Schedule 3 (General Details) hereto, being the date of execution of this Agreement. `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>“Facility Letter”</Text>
              {` shall mean the Facility Letter vide which the KSOS has sanctioned short term finance/loan to the Channel Partner, a copy of which is annexed herewith in Schedule 1. `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>
                "Finance Company' or "Finance Companies"
              </Text>
              {` shall mean and include banks, non-banking finance companies ("NBFC") or any other financial institutions who have entered into an agreement with KSOS or its affiliates for marketing, promotion and sourcing of customers for various Financial Products offered by them. `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>"Financial Products"</Text>
              {` shall mean and include various vehicle financial products (like channel finance, used vehicle retail finance, insurance, warranty, and any other similar products etc.) marketed, and promoted by KSOS or its affiliates on behalf of any Finance Company. This definition also includes any additional products or services that may be introduced or added by KSOS or its affiliates from time to time, whether of a similar nature or otherwise. `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>“Facility Amount”</Text>
              {` shall mean the mean the total amount which can be disbursed by KSOS under the Loan   Facility, at any point in time, which amount shall be as more particularly set out in the Facility Letter. `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>“Loan Facility”</Text>
              {` shall mean revolving credit line provided by Finance Companies on KSOS Platform to Channel Partners  `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>“Margin Money”</Text>
              {` shall mean % of the amount as per Credit Request Letter paid by the Channel Partner upfront to KSOS for availing the Loan Facility `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>
                “Principal Amount”, “Interest Amount”, “Overdue Interest
                Amount”, “Back-out Fees”, “Loss on sale of asset”
              </Text>
              {` shall be as per specification provided in Facility Letter. `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>“Seller”</Text>
              {` shall mean and include banks, non-banking finance companies ("NBFC"), any other financial institutions, new vehicle dealer, broker or any person who have entered into an agreement with KSOS or its affiliates for selling vehicle by KSOS on their Platform `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>"Lead/Leads"</Text>
              {` shall have the meaning ascribed to it in Recital B. `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>"Service"</Text>
              {` shall mean the services set out in clause 3 of this Agreement. `}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              <Text style={styles.bold}>“Payment Authorization Letter”</Text>
              {` shall mean confirmation/go-ahead (duly signed by the Lead) provided by the Channel Partner / Lead to KSOS to transfer the payment of the disbursed loan amount as per the break-up provided in the letter. `}
            </Text>
          </View>
          {/* 2. TERM: */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`2.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {`TERM `}
              </Text>
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              {` This Agreement shall come into force on and from the Effective Date and shall remain effective for a period of five (5) years / 60 months from the Effective Date, unless terminated in accordance with the provisions of Clause 10 of this Agreement `}
              <Text style={styles.bold}> ("Term").</Text>
            </Text>
          </View>
          {/* 3.SCOPE OF Channel Partner SERVICES AND ITS OBLIGATIONS */}
          {/* Clause 3 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`3.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {`SCOPE OF Channel Partner SERVICES AND ITS OBLIGATIONS `}
              </Text>
            </Text>
          </View>
          {/* Clause 3.1 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`3.1`}</Text>
              <Text style={styles.bold}>
                {" "}
                When the Channel partner sources customer availing Financial
                Products:
              </Text>
            </Text>
          </View>
          {/* Clause 3.1.1 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              {`3.1.1 Channel Partner will refer the Leads, who require loan/finance for purchase of used vehicles and who may be prospective customers for the Financial Products promoted and marketed by KSOS on behalf of Finance Companies. Channel Partner shall also provide such other services, functions, and fulfil responsibilities which are reasonably required for, and related to, for the proper performance and provisions of the Services `}
              <Text style={styles.bold}>{`("Services"). `}</Text>
              {`The Channel Partner shall perform its obligations under this Agreement in accordance with best industry practice, all applicable laws, KSOS's policies and reasonable instructions from time to time.`}
            </Text>
          </View>
          {/* Clause 3.1.2 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0 },
              ]}
            >
              {`3.1.2   The Channel Partner shall perform the following obligations as part of the Services: `}
            </Text>
          </View>
          {/* Clause 3.1.2    i.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`i.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner will refer the Leads with details such as customer name, email ID, mobile number, city, pin code, income level, identified vehicle details, and such other information and documents as may be required by KSOS `}
              <Text style={styles.bold}>{`("Lead Information").`}</Text>
            </Text>
          </View>
          {/* Clause 3.1.2    ii.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`ii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                  // marginLeft: 35,
                },
              ]}
            >
              {`Channel Partner shall forward the Leads based on its own preliminary assessment and by using the filter criteria and different kinds of validation checks, as communicated by KSOS from time to time `}
            </Text>
          </View>
          {/* Clause 3.1.2    iii.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`iii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Prior to transferring Leads to KSOS, Channel Partner shall obtain express written consent from the Leads for transferring their Lead Information to KSOS and Financial Companies for the purpose of obtaining Financial Products and allied services `}
            </Text>
          </View>
          {/* Clause 3.1.2    iv.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`iv.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`If KSOS finds that the Lead fulfills the eligibility criteria notified by a particular Finance Company, KSOS will intimate the same to Channel Partner and ask Channel Partner to obtain from the Lead a duly filled loan application and other initial documents, to enable such Finance Company to process the loan application of the Lead`}{" "}
            </Text>
          </View>
          {/* Clause 3.1.2    v.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`v.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`On receipt of confirmation from the Finance Company of its acceptance of a loan application, Channel Partner shall obtain completed loan documentation as per Finance Company policy and collect such documents, proofs, processing, or service charges as may be required for processing Lead's loan application. The list of documents required to be collected from Leads will be communicated by KSOS from time to time. Channel Partner shall make sure that all required information and documents are collected after in-depth scrutiny and due verification with the originals thereof and are true, correct, and complete in all respects. The documents to be collected by Channel Partner shall without limitation include i) Original Registration Certificate (RC); ii) Duly signed Form 29; iii) Duly signed Form 30; iv) Insurance Copy (at least 30 days valid); v) Payment Authorization Letter duly signed by the Leads in the form and manner given in Schedule 2; vi)payee KYC and cancelled cheque; vii) Lead local address proof and other KYC documents; viii) Duly signed Form 35 and NOC/Loan foreclosure letter in case of existing loan and hypothecation on vehicle; ix) company NOC in case the registered owner of the vehicle is a company; x) CNG Certificate in case the fuel type of vehicle is CNG; xi) Clearance Certificate if there is inter-RTO transfer case; and such other document or information as required by Finance Company or KSOS. In particular, before forwarding any loan application, Channel Partner shall verify and ensure that the Registration Certification (RC) of the vehicle has been duly registered in the name of owner of the vehicle/seller and said RC is duly authenticated from Regional Transport Office (RTO)`}{" "}
            </Text>
          </View>
          {/* Clause 3.1.2    vi.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`vi.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner shall ensure that the title of the Vehicle is not tainted or defective, it is free from all encumbrances and good and marketable. As part of Vehicle delivery receipt, Channel Partner will also obtain a declaration from registered owner of the Vehicle stating that the encumbrances and all taxes have been paid till date and the registered owner is fully authorized and empowered to sell the Vehicle. For avoidance of doubt, any existing loan on the Vehicle, if any, will be disclosed upfront. The said loan will be settled by the registered owner of Vehicle and the Channel Partner shall ensure loan closure certificate/NOC from existing lender regarding closure of loan on such Vehicle`}
            </Text>
          </View>
          {/* Clause 3.1.2    vii.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`vii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`On receiving the loan documentation, Finance Company shall, if satisfied that the loan documentation is complete, disburse to KSOS the loan amount`}{" "}
            </Text>
          </View>
          {/* Clause 3.1.2    viii.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`viii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner shall then facilitate to provide Payment Authorization Letter duly signed by the Lead to ensure that the payment of the disbursed loan amount is either made by KSOS (i) to the Channel Partner facilitating sale/purchase of Vehicle; or (ii) to the owner/seller of Vehicle; or (iii) to any third party or the Lead. However, in case of (i) refinancing of existing used Vehicle, such loan payment will be made to the lender bank/finance company of such Vehicle which in turn will issue loan closure certificate; and (ii) in case of top up loans, the loan amount will be paid to owner of the Vehicle, or any third party authorized by such owner`}
            </Text>
          </View>
          {/* Clause 3.1.2    ix.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`ix.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Within 60 days of disbursement of loan amount for the Vehicle by KSOS, Channel Partner shall get the Vehicle transferred in the name of the Lead/purchaser of the Vehicle and get the concerned Finance Company's hypothecation endorsement over the Vehicle to secure such Financial Company's grant of loan to the Lead/Purchaser`}
            </Text>
          </View>
          {/* Clause 3.1.2    x.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`x.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner agrees, undertakes, and confirms that Channel Partner shall make the payment of amount paid by KSOS to it or any third party instructed by it, to the registered owner of the Vehicle in discharge of the sale price/balance sale consideration to be paid to the registered owner of the Vehicle. Channel Partner acknowledges that payment of disbursed loan amount from KSOS to Channel Partner account or any third party instructed by it shall be a valid discharge from the registered owner to KSOS towards the sale price of Vehicle. Furthermore, failure on the part of the Channel Partner to make the payment as aforesaid shall constitute acknowledged debt on the Channel Partner and KSOS reserves any right to recover such debt amount along with interest thereon and legal costs and expenses`}
            </Text>
          </View>
          {/* Clause 3.1.2    xi.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`xi.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner guarantees that the Registration Certificate, Forms relating to transfer of Vehicle and other documents including all the representation and warranties are good and valid for Channel Partner to complete RC transfer in favour of Lead/buyer of Vehicle and hypothecation endorsement in favour of Financial Company within 60 days from the date of disbursement of loan ("Post Disbursement Obligations" or "PDD"). If Channel Partner is not able to complete the RC transfer and hypothecation noting at RTO Office within 60 days timeframe as mentioned hereinbefore due to any reason including without limitation reasons such as non-payment of sale consideration by Channel Partner to registered owner of Vehicle, non-handover of original RC or any Vehicle transfer forms or other documents required for completion of RC transfer, incomplete or untrue or incorrect Vehicle transfer documents or any information pertaining to loan application and its documentation, any objection raised by registered owner of the Vehicle in RC transfer or hypothecation formalities, and any dispute or litigation raised by Channel Partner or registered owner or any third party relating to title of the Vehicle, then Channel Partner shall be liable to refund of entire loan amount disbursed to it by KSOS, within 7 (seven) days after the expiry of abovementioned 60 days period. In case of delay in refund of loan amount by Channel Partner beyond 7 (seven) days period mentioned above then Channel Partner shall be liable to pay interest on loan disbursed amount, penalty, loan foreclosure amount and interest thereon as may be charged or demanded by concerned Financial Company from KSOS along with an interest @2% per month till the date of realization. This is without prejudice to any other rights, remedies available to KSOS under this Agreement or applicable laws or equity. At the sole option of KSOS, Channel Partner may be asked to furnish an interest free security deposit to KSOS equivalent to the disbursed loan amount within 7 (seven) days. KSOS agrees to release the security deposit so furnished as soon as the Vehicle RC is transferred and hypothecation noting is completed. KSOS may also ask for Post Dated Cheques (PDC) for an amount determined by KSOS in its sole discretion for providing RC limit facility to Channel Partner. KSOS shall be entitled to enforce the security deposit, in full, upon Finance Company exercising similar rights against KSOS for non-registration of RC in favour of buyer of Vehicle and hypothecation noting. Furthermore, failure on the part of the Channel Partner to make the payment as aforesaid shall constitute acknowledged debt on the Channel Partner and KSOS reserves any right to recover such debt amount along with interest thereon and legal costs and expenses`}
            </Text>
          </View>
          {/* Clause 3.1.3 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 20,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`3.1.3`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`In addition to above obligations pertaining to loan process, review, disbursement and Post Disbursement Obligations, the Channel Partner shall also comply with the following  `}
            </Text>
          </View>
          {/* Clause 3.1.3    i.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`i.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner shall render, and shall ensure that Lead also renders, all necessary support and co-operation required by KSOS in relation to i) loan approval process; and ii) Post Disbursement Obligations.`}
            </Text>
          </View>
          {/* Clause 3.1.3    ii.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`ii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner shall keep KSOS informed about all disputes and complaints received by it with respect to Vehicle financed or to be financed pursuant to the terms of this Agreement.`}
            </Text>
          </View>
          {/* Clause 3.1.3    iii.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`iii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner shall promptly assist KSOS without any demur or cavil on a best-efforts basis in KSOS resolving all queries, complaints and claims made by either owner of Vehicle or seller/borrower of the vehicle in regard to and/or in respect of and/or arising out of any obligations covered under this Agreement.`}
            </Text>
          </View>
          {/* Clause 3.1.3    iv.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`iv.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner shall promptly inform KSOS of any event or situation which may affect its ability to fulfil its obligations under this Agreement, including but not limited to any situation which may adversely affect the RC transfer and hypothecation noting.`}
            </Text>
          </View>
          {/* Clause 3.1.3    v.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`v.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner shall be solely responsible for ensuring compliance of tax laws and other applicable laws by both the seller and buyer of the Vehicle.`}
            </Text>
          </View>
          {/* Clause 3.1.3    vi.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`vi.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner shall always conduct its business in an ethical manner and adhere to good governance, compliance with anti-bribery laws, and other standards as communicated by KSOS.`}
            </Text>
          </View>
          {/* Clause 3.1.3    vii.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`vii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner shall maintain an accurate record and accounts of all the Leads provided by it to KSOS including loan application, KYC and other documents provided along with loan application, proof of payment to owner of Vehicle, bank statements covering financial transactions, Vehicle delivery receipt, etc.`}
            </Text>
          </View>
          {/* Clause 3.1.4 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 20,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`3.1.4`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`In case KSOS, to protect its own interest, has incurred any liability for Channel Partner's failure to comply with any term and condition of this Agreement, Channel Partner hereby unconditionally assign and transfer to KSOS all rights, title, and interest which Channel Partner may have or claim against registered owner/seller of the Vehicle or Lead or any person or persons associated in the matter or in respect thereof. This consent will be assumed as irrevocable letter of subrogation and special power of attorney by Channel Partner in favour of KSOS and Channel Partner hereby unconditionally authorize KSOS to use Channel Partner's name in any action or proceedings (including any claim recovery for loss or damages) KSOS may bring in relation to any of the matters hereby assigned and transferred to KSOS, and Channel Partner undertake to concur in any such action or proceedings, and execute all documents which may be necessary, and generally to assist therein by all means.`}
            </Text>
          </View>
          {/* Clause 3.2 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: -5,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`3.2`}</Text>
              <Text style={styles.bold}>
                {" "}
                When the Channel Partner himself avails the Financial Products
              </Text>
            </Text>
          </View>
          {/* Clause 3.2.1 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 20,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`3.2.1`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`Channel Partner will avail themselves of Financial Products promoted and marketed by KSOS on behalf of Finance Companies. Channel Partner shall also provide such other services, functions, and fulfil responsibilities which are reasonably required for, and related to, for the proper performance and provisions of the Services ("Services"). The Channel Partner shall perform its obligations under this Agreement in accordance with best industry practice, all applicable laws, KSOS's policies and reasonable instructions from time to time.`}
            </Text>
          </View>
          {/* Clause 3.2.2 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 20,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`3.2.2`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`The Channel Partner shall perform the following obligations as part of the Services:`}
            </Text>
          </View>
          {/* Clause 3.2.2    i.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`i.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner will provide signed application form / email consent along with required KYC and 2 signed security PDC as per the requirement of KSOS & Finance Companies for getting empaneled / setting the limit with KSOS`}
            </Text>
          </View>
          {/* Clause 3.2.2    ii.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`ii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner in scenario where he is the winning bidder on the Platform, hereby unconditionally assign and provide consent to transfer the right/interest to KSOS to change the name of the winning bidder (name of Channel Partner) to KSOS in auction completion report sent to the Seller and any other further communications related to the bid.`}
            </Text>
          </View>
          {/* Clause 3.2.2    iii.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`iii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner will provide signed Credit Request Letter (as per Schedule 4) to KSOS for availing short-term finance/loan from partner Finance Companies on the approvals (consent to sell) provided by the Seller to KSOS`}
            </Text>
          </View>
          {/* Clause 3.2.2    iv.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`iv.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`If KSOS finds that the Channel Partner fulfills the eligibility criteria notified by a particular Finance Company, KSOS will intimate the same to Channel Partner and ask Channel Partner to deposit Margin Money & processing fees (as mentioned in Credit Request Letter) and yard charges to KSOS bank account (as per Annexure C)`}
            </Text>
          </View>
          {/* Clause 3.2.2    v.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`v.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`On receiving the request from Channel Partner and receipt of Margin Money, processing fees & yard charges, Finance Company shall, if satisfied that the loan documentation is complete, disburse balance amount (less of Margin Money) of the total asset value to KSOS and KSOS will transfer the 100% of the total asset value to the Seller`}
            </Text>
          </View>
          {/* Clause 3.2.2    vi.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`vi.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Within 60 days of disbursement of loan amount for the vehicle by KSOS through Finance Companies, Channel Partner shall ensure repayment of loan amount along with interest & other finance charges (if any) and transfer the total amount to KSOS in KSOS bank account as per information provided in Annexure C`}
            </Text>
          </View>
          {/* Clause 3.2.3 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 20,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`3.2.3`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`In addition to above obligations pertaining to loan process, review, disbursement and Post Disbursement Obligations, the Channel Partner shall also comply with the following:`}
            </Text>
          </View>
          {/* Clause 3.2.3    i.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`i.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner shall keep KSOS informed about all disputes and complaints received by it with respect to vehicle financed or to be financed pursuant to the terms of this Agreement.`}
            </Text>
          </View>{" "}
          {/* Clause 3.2.3    ii.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`ii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner shall promptly assist KSOS without any demur or cavil on a best-efforts basis in KSOS resolving all queries, complaints and claims made by either owner of vehicle or seller of the vehicle regarding and/or in respect of and/or arising out of any obligations covered under this Agreement.`}
            </Text>
          </View>{" "}
          {/* Clause 3.2.3    iii.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`iii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner shall promptly inform KSOS of any event or situation which may affect its ability to fulfil its obligations under this Agreement, including but not limited to any situation which may adversely affect the repayment of short-term loan availed `}
            </Text>
          </View>
          {/* Clause 3.2.3    iv.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 35 }}>{`iv.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Channel Partner shall always conduct its business in an ethical manner and adhere to good governance, compliance with anti-bribery laws, and other standards as communicated by KSOS.`}
            </Text>
          </View>
          {/* Clause 3.2.4 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 20,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`3.2.4`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`In case KSOS, to protect its own interest, has incurred any liability for Channel Partner's failure to comply with any term and condition of this Agreement, Channel Partner hereby unconditionally assign and transfer to KSOS all rights, title, and interest which Channel Partner may have against the vehicle. This consent will be assumed as irrevocable letter of subrogation and special power of attorney by Channel Partner in favour of KSOS and Channel Partner hereby unconditionally authorize KSOS to use Channel Partner's name in any action or proceedings (including any claim recovery for loss or damages) KSOS may bring in relation to any of the matters hereby assigned and transferred to KSOS, and Channel Partner undertake to concur in any such action or proceedings, and execute all documents which may be necessary, and generally to assist therein by all means.`}
            </Text>
          </View>
          {/* Clause 4 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`4.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {`ksos’S OBLIGATIONS `}
              </Text>
            </Text>
          </View>
          {/* Clause 4.1 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`4.1`}</Text>
              <Text style={styles.bold}>
                {" "}
                KSOS Obligations pertaining to sourcing customers:
              </Text>
            </Text>
          </View>
          {/* Clause 4.1.1 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 20 }}>{`4.1.1`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`KSOS will change the name of the winning bidder as explained in clause 3.2.2 while sending auction completion report to seller.`}
            </Text>
          </View>
          {/* Clause 4.1.2 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 20 }}>{`4.1.2`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`Once the loan application of the Channel Partner is approved and loan amount is disbursed by Finance Company to KSOS, the loan amount approved/released by Financial Company in the name of Channel Partner, shall be paid to Seller as per the Credit Request Letter given by the Channel Partner subject to Channel Partner's compliance of other terms and conditions of this Agreement including receipt of Margin Money of the amount as given in Clause 3.2.2`}
            </Text>
          </View>
          {/* Clause 4.1.3 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 20 }}>{`4.1.3`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`KSOS will provide detailed account statement at the time of the closure of the loan to the Channel Partner and follow waterfall mechanism as per below mentioned priority order related to closure of the loan:`}
            </Text>
          </View>
          {/* Clause 4.1.3    i.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 40,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 55 }}>{`i.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Finance Companies Processing Fees `}
            </Text>
          </View>
          {/* Clause 4.1.3    ii.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 40,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 55 }}>{`ii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Finance Companies Overdue Interest Amount`}
            </Text>
          </View>
          {/* Clause 4.1.3    iii.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 40,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 55 }}>{`iii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Finance Companies Interest Amount`}
            </Text>
          </View>
          {/* Clause 4.1.3    iv.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 40,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 55 }}>{`iv.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Finance Companies Principal Amount`}
            </Text>
          </View>
          {/* Clause 4.1.3    v.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 40,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 55 }}>{`v.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`KSOS Back-out Fees `}
            </Text>
          </View>
          {/* Clause 4.1.3    vi.    Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 40,
              marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 55 }}>{`vi.`}</Text>
            <Text
              style={[
                styles.paragraph,
                {
                  flex: 1,
                  textAlign: "justify",
                  lineHeight: 1.5,
                  marginBottom: 0,
                  marginTop: 0,
                },
              ]}
            >
              {`Loss on sale of asset incurred to KSOS`}
            </Text>
          </View>
          {/* Clause 4.2 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20, marginLeft: 20 }}>{`4.2`}</Text>
              <Text style={[styles.bold, { marginLeft: 20 }]}>
                {" "}
                KSOS Obligations when the Channel Partner himself avails the
                Financial Products:
              </Text>
            </Text>
          </View>
          {/* Clause 4.2.1 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 20 }}>{`4.2.1`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`Once the loan application of the Lead is approved and loan amount is disbursed by Finance Company to KSOS, the loan amount approved/released by Financial Company in the name of Lead, shall be paid as per the Payment Authorization Letter given by the Lead and subject to Channel Partner's compliance of other terms and conditions of this Agreement including furnish of documents as given in Clause 3.1.2`}
            </Text>
          </View>
          {/* Clause 4.3 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`4.3`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 0 },
              ]}
            >
              {`Decision of KSOS regarding any discrepancy or calculations mentioned in account statement payable by Channel Partner shall be final and binding upon the Channel Partner.`}
            </Text>
            {/* </Text> */}
          </View>
          {/* Clause 5 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`5.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {`CONSIDERATION  `}
              </Text>
            </Text>
          </View>
          {/* Clause 5.1 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20, marginLeft: 20 }}>{`5.1`}</Text>
              <Text style={[styles.bold, { marginLeft: 20 }]}>
                {"  "}
                Consideration for sourcing customers:
              </Text>
            </Text>
          </View>
          {/* Clause 5.1.1 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`5.1.1`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`KSOS agrees to remunerate the Channel Partner for the provision of Services rendered by Channel Partner culminating into disbursal of loan amount by Finance Companies, a certain percentage of loan disbursal amount as commission (hereinafter referred to as "Fee") as set out in Annexure A. Such commission shall be payable only after transfer of registration certificate in the name of purchaser of the Vehicle and endorsement of hypothecation in favour of the concerned Finance Company which has provided the loan facility to purchaser.`}
            </Text>
          </View>{" "}
          {/* Clause 5.1.2 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`5.1.2`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`The Fee during the subsistence of this Agreement may be revised by KSOS at its discretion with prior intimation to the Channel Partner in writing by way of email or update through any electronic communication. All act/omissions basis said communication will be deemed acceptance of such terms. Payment of Fee shall be subject to any deductions for defaults or deficiencies in meeting obligations, performance parameters and unless otherwise specified shall be inclusive of all other costs, expenses, as may become due and payable in relation to the Services.`}
            </Text>
          </View>
          {/* Clause 5.1.3 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`5.1.3`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`On or before 20th day of each month, KSOS will calculate the Fee payable by KSOS to Channel Partner for the provision of the Services rendered during the immediately preceding month in accordance with applicable rates, valid and effective for such immediately preceding month, and upon confirmation of Fee payable for previous month, Channel Partner shall raise an invoice for the Fee payable to it by KSOS for provision of Services rendered. KSOS shall make payment to the registered account of the Channel Partner within 30 days of receipt of the invoice in accordance with the calculations detailed out in the email or any electronic communication.`}
            </Text>
          </View>
          {/* Clause 5.1.4 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`5.1.4`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`In the event of any discrepancy in payment of Fee, Channel Partner shall immediately and in no event later than 10 (ten) days of receipt of such payment, revert in writing to KSOS or its authorized representative with details and description of such discrepancy.`}
            </Text>
          </View>
          {/* Clause 5.1.5 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`5.1.5`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`In the event it is determined, in sole discretion of the KSOS, that the discrepancy or mistake highlighted by Channel Partner is genuine, KSOS will either adjust such corrected Fee payable to the Channel Partner in the next payment cycle or through an appropriate adjustment to account, as KSOS may deem fit in accordance with applicable tax laws.`}
            </Text>
          </View>
          {/* Clause 5.1.6 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`5.1.6`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`Decision of KSOS regarding any discrepancy or calculations mentioned in Fees payable to Channel Partner shall be final and binding upon the Channel Partner.`}
            </Text>
          </View>
          {/* Clause 5.1.7 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`5.1.7`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`The Fee under this Agreement will be paid within 30 days from the date of receipt of complete and valid invoice. All payments to the Channel Partner by KSOS under this Agreement shall be subject to deduction of tax at source as per applicable laws. The Fee payable shall inclusive of all taxes, rates, cess applicable on the Fee including GST.`}
            </Text>
          </View>
          {/* Clause 5.1.8 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`5.1.8`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`Channel Partner shall raise the valid tax invoice in compliance with GST laws to enable the Company to make the payment of Fee. However, if Channel Partner is an exempted entity under GST Laws, then Channel Partner shall provide the declarations to this effect in a format and manner acceptable by the Company.  Channel Partner further acknowledges and agrees that whenever Channel Partner crosses the exemption limit prescribed under the GST Laws for unregistered entity or apply under the composition scheme or otherwise ceases to remain outside the scope of GST registration then Channel Partner shall forthwith get itself duly registered under GST and provide its GSTIN to KSOS and accordingly shall be obliged to raise the valid tax invoice to claim the payment of the Fee.`}
            </Text>
          </View>
          {/* Clause 5.1.9 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`5.1.9`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`In the event where the Input Tax Credit of GST paid to Channel Partner on the basis of Channel Partner's tax invoice is denied or restricted for KSOS due to non-payment of such GST or non-filing of GST returns by Channel Partner or incorrect bifurcation or HSN/SSN Code, then, KSOS shall be entitled to recover or adjust the loss of Input Tax Credit and interest thereon borne by it due to noncompliance by Channel Partner.`}
            </Text>
          </View>
          {/* Clause 5.1.10 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`5.1.10`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`Where Channel Partner has incurred any liability to KSOS, whether arising from or under this Agreement or otherwise, KSOS may without notice to Channel Partner deduct/adjust/set-off the amount of such liability against any liability of KSOS to Channel Partner arising from or under this Agreement, whether such liability is liquidated or unliquidated, present or future, accrued or contingent`}
            </Text>
          </View>
          {/* Clause 5.2 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20, marginLeft: 20 }}>{`5.2`}</Text>
              <Text style={[styles.bold, { marginLeft: 20 }]}>
                {"  "}
                Consideration when the Channel Partner himself avails the
                Financial Products:
              </Text>
            </Text>
          </View>
          {/* Clause 5.2.1 Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`5.2.1`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`KSOS agrees that in instances where the Channel Partner directly avails Financial Products through KSOS partner Finance Companies, any applicable fees, charges, or other financial considerations will be outlined in the Facility Letter or relevant transaction documents. Such fees shall be determined based on the terms agreed between KSOS, the Finance Company, and the Channel Partner, and may be subject to adjustments based on applicable interest rates, service charges, and any other associated costs as specified in the Facility Letter. Payment or settlement of these amounts shall follow the terms and conditions detailed in this Agreement and any relevant financing documents.`}
            </Text>
          </View>
          {/* Clause 6 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`6.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {`RC FACILITY  `}
              </Text>
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text style={[styles.paragraph, { marginLeft: 20 }]}>
              {`KSOS is appointed by Finance Company for sourcing used vehicles finance business. The partner/dealer network of KSOS facilitates the sale/purchase of used vehicles. Finance Company desires KSOS and its dealer partners to ensure the transfer of ownership with the RTO in favor of customer with lien in favor of Finance Company on the vehicle within certain fixed time frame.`}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text style={[styles.paragraph, { marginLeft: 20 }]}>
              {`That on the basis of Channel Partner' representation that it shall transfer the registration certificate of the vehicle in favour of the purchaser and also endorsement of Finance Company's hypothecation over the vehicle in the transferred registration certificate within 60 days of disbursement of loan, KSOS agrees to disburse loan amount against used vehicle finance application prior to transfer of ownership/registration certificate in the records of concerned RTO in favor of purchaser and hypothecation endorsement of Finance Company on the registration certificate of the vehicle and this facility is called `}
              <Text style={[styles.bold, { marginLeft: 20 }]}>
                "RC Facility".
              </Text>{" "}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text style={[styles.paragraph, { marginLeft: 20 }]}>
              {`The RC Facility shall be expressed as maximum number of RC's pending for hypothecation in favor of Finance Company after disbursement of loan by KSOS or total amount of loan cases disbursed by KSOS where RC transfer is pending at any point in time.`}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text style={[styles.paragraph, { marginLeft: 20 }]}>
              {`KSOS has agreed to grant Channel Partner RC Facility of `}
              <Text style={[styles.bold, { marginLeft: 20 }]}>15 No.</Text>

              {` RCs or Cumulative amount (Total Disbursed amount) equivalent to`}
              <Text style={[styles.bold, { marginLeft: 20 }]}>
                {" "}
                INR Fifty Lacs
              </Text>
              {` only whichever is exhausted first, subject to Channel Partner furnishing postdated cheques for equivalent amount as security deposit.`}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text style={[styles.paragraph, { marginLeft: 20 }]}>
              {`Where Channel Partner agrees to provide security cheques to KSOS in furtherance to above referred RC Limit and Channel Partner' obligations under the Agreement and the said security cheques will not be encashed by KSOS except in case off failure to meet the obligations covered below:`}
            </Text>
          </View>
          {/* Clause 6  i. Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`i.`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`It will be absolute duty of the Channel Partner to obtain all papers, documents as are required for the finance scheme and transfer of the vehicle with the endorsement of Finance Company in favor of the Lead/purchaser of the vehicle and Channel Partner shall perform its obligations without fail, duly, punctually and in a timely manner.`}
            </Text>
          </View>
          {/* Clause 6  ii. Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`ii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`Channel Partner confirms and undertakes that it shall submit all forms and documents required for transfer of the vehicle in the name of purchaser with concerned RTO immediately upon receipt of payment by it from KSOS`}
            </Text>
          </View>
          {/* Clause 6  iii. Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`iii.`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`Upon completion of the registration formalities of the vehicle in favor of the purchaser along with endorsement of hypothecation of the concerned Finance Company duly recorded in the transferred registration certificate, Channel Partner shall furnish a certified true copy to KSOS as documentary evidence of the registration having completed as per requirement of the KSOS and Finance Company`}{" "}
            </Text>
          </View>
          {/* Clause 6  iv. Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 30,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`iv.`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 10 },
              ]}
            >
              {`It is agreed and understood, and Channel Partner expressly declares and confirms to KSOS as under;`}
            </Text>
          </View>
          {/* Clause 6  iv.  a. Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 60,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`a.`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 0 },
              ]}
            >
              {`Wherever the Finance Company has granted the loan facility to a Lead referred by Channel Partner to KSOS and KSOS has made disbursement of the loan amount to Channel Partner or owner of the vehicle or any third party basis Payment Authorized Letter furnished by Channel Partner, such loan is disbursed by KSOS on the basis of representation made by Channel Partner that the vehicle is free from all encumbrances and the title thereof is not tainted or defective and is good and marketable and believing the representation to be true KSOS has disbursed the loan amount to Channel Partner or any third party basis Payment Authorized Letter furnished by Channel Partner, therefore so long as the vehicle is not transferred in the name of the purchaser/Lead and endorsement of concerned Finance Company is not done on the transferred RC, Channel Partner shall continue to be obliged in respect of its representations herein stated and in the event during the subsistence of the finance facility to the Lead or any time thereafter it is found or discovered that the vehicle for which finance facility is granted to Lead is encumbered or title thereof is tainted or defective and/or vehicle or ownership proofs/RC is not good and in marketable condition and thereby KSOS suffers any loss, damages, cost, expenses, penalty, then in such event Channel Partner shall keep KSOS saved, indemnified, and hold harmless against such loss, damages, claims, expenses, liability or penalty suffered or likely to be suffered by KSOS.`}
            </Text>
          </View>
          {/* Clause 6  iv.  b. Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 60,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`b.`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 0 },
              ]}
            >
              {`It is further agreed between KSOS and Channel Partner that upon KSOS suffering such a loss or is likely to suffer such a loss then KSOS shall have an unfettered right to appropriate such amounts out of any dues that KSOS has to pay to the Lead from their then on-going loan facility for any other vehicle, if any`}
            </Text>
          </View>
          {/* Clause 6  iv.  c. Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 60,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`c.`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 0 },
              ]}
            >
              {`Appropriation of this nature by KSOS out of the amounts payable to Channel Partner shall not in any way absolve Channel Partner from making payment of such sums as KSOS may have suffered loss or liability on account of vehicle not being transferred in the name of buyer along with hypothecation endorsement of concerned Finance Company within 60 day of disbursement of loan, or title of vehicle is found tainted or defective and not free and marketable or encumbered and in such event liability of Channel Partner shall continue and subsist.`}
            </Text>
          </View>
          {/* Clause 6  iv.  d. Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 60,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`d.`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 0 },
              ]}
            >
              {`Failure of Channel Partner to make payment as aforesaid shall constitute breach of this Agreement and RC Limit Facility entitling KSOS to take such action as KSOS may deem fit for recovery of any amounts paid by KSOS to Channel Partner and/or any other action permitted under law`}
            </Text>
          </View>
          {/* Clause 6  iv.  e. Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 60,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`e.`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 0 },
              ]}
            >
              {`KSOS has granted this credit facility to the Lead on the basis of the representations made by Channel Partner as herein contained which amongst others include that the transfer of registration certificate of the vehicle in favor of the purchaser and endorsement of Finance Company's hypothecation in the registration certificate of the vehicle shall be completed by Channel Partner without fail within 60 days of disbursement of the loan amount by KSOS and if for any reason whatsoever, it is found or discovered that any of its representations are not true or that Channel Partner has failed to get the RC transfer and hypothecation endorsement of the concerned Finance Company within 60 days as stated above, then KSOS shall be entitled to terminate this contract after providing Channel Partner a cure period of 7 (seven) calendar days to cure such defect, failing which, KSOS shall be entitled to appropriate the security deposit amount furnished by Channel Partner in addition to any other remedy KSOS is entitled to under law`}
            </Text>
          </View>
          {/* Clause 6  iv.  f. Content */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 60,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20 }}>{`f.`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 0 },
              ]}
            >
              {`Channel Partner shall give to KSOS a Post Dated Cheque (PDC) as per Annexure B for the credit facility which KSOS can appropriate to recover its dues against Channel Partner in case there is any default by Channel Partner of the terms and conditions of this Agreement entitling KSOS to recall entire credit facility and also KSOS shall be entitled to encash the PDC's upon termination of this Agreement or upon Channel Partner default or violation of terms and conditions of this Agreement and upon such termination KSOS is entitled to receive back from Channel Partner the credit facility and loan disbursed to it for which RC transfer facility is not completed by Channel Partner or any portion thereof`}
            </Text>
          </View>
          {/* Clause 7 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`7.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {`REPRESENTATIONS AND WARRANTIES  `}
              </Text>
            </Text>
          </View>
          {/* Clause 7.1 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`7.1`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              {` Channel Partner hereby represents and warrants that execution of this Agreement and delivery and performance of its duties, obligation and responsibilities hereunder do not and shall not conflict with, result in a breach of or default under applicable laws or any order, writ, injunction or decree of any court or Government Authority, or any agreement, understanding or arrangement, written or oral, to which it is a party.`}
            </Text>
          </View>
          {/* Clause 7.2 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`7.2`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              {` Channel Partner hereby represents and warrants that: (a) the Leads are true and genuine, and Channel Partner has verified the authenticity of the Lead Information; (b) the Vehicle information such as Registration Certificate, hypothecation, ownership etc. has been verified as true and correct; (c) execution of this Agreement and delivery and performance of its duties, obligation and responsibilities hereunder do not and shall not conflict with, result in a breach of or default under applicable laws or any order, writ, injunction or decree of any court or Government Authority, or any agreement, understanding or arrangement, written or oral, to which it is a party; (d) it shall duly pay the duties, taxes and levies as are required to be paid by it under this Agreement; (e) it has requisite knowledge, experience, infrastructure, resources and capacity to carry out the Services and obligations; and (f) there is no litigation or proceeding or dispute pending or threatened against it or any affiliate or related party which may affect its ability to provide the Services in accordance with the terms of this Agreement and/or have an adverse impact on the Services or the quality and integrity thereof, in any manner Channel Partner acknowledges that the Company has executed this Agreement on the basis of, and in full reliance on, each of the aforesaid representations and warranties `}
            </Text>
          </View>
          {/* Clause 7.3 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`7.3`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              {`The Channel Partner further represents that KSOS may directly provide additional services to any Lead without any involvement of Channel Partner and for which Channel Partner shall not be entitled to any commission unless agreed otherwise`}
            </Text>
          </View>
          {/* Clause 7.4 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`7.4`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              {`It is clearly understood that Channel Partner is not authorized to hold out any representations, promises, assurances and/or guarantees to prospective applicant(s), Leads regarding processing or acceptance of loan proposals.`}
            </Text>
          </View>
          {/* Clause 7.5 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`7.5`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              {`Channel Partner acknowledges that the Channel Partner and KSOS's role is primarily that of a facilitator and a catalyst and in no circumstances the Channel Partner or Channel Partner's employee, agent or staff will accept any deposit, margin money and/or installment amount(s) directly from anyone in respect of the Financial Products`}
            </Text>
          </View>
          {/* Clause 8 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`8.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {`INDEMNITY  `}
              </Text>
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 10,
            }}
          >
            <Text style={[styles.paragraph, { marginLeft: 20 }]}>
              {`Channel Partner shall indemnify, defend and hold harmless KSOS and its directors, employees, officers against any and all losses, costs, liabilities, judgments, expenses or damages (including reasonable attorney's fees), arising out of (i) claims including any third party claims arising out of Services provided by the Channel Partner hereunder; (ii) claims due to infringement of intellectual property rights of any third party; (iii) any breach by Channel Partner of its representations, warranties, promises, undertakings, assurances, declarations, confirmations, acceptance, covenants and obligations under this Agreement; (iv) breach/non-performance or inadequate performance of any terms, conditions, covenants, undertakings, obligations of this Agreement or deficient Services or breach of applicable law, rules and regulation by the Channel Partner or its employees, agent or staff; (v) claims if it is discovered or found that the vehicle financed is encumbered and/or the title thereof is tainted or defective and/or not good and marketable; (vi) any wrongful, incorrect, dishonest, criminal, fraudulent, willful, negligent or unauthorized acts, misuse, omission, fraud/forgery, misconduct or misrepresentation by the Channel Partner or its employees, agents and staff; and (vii) breach of Channel Partner or Channel Partner's employee, agent or staff's obligation of maintaining confidentiality, privacy of the Lead Information; (viii) Failure or inability of Channel Partner to get the registration certificate of the Vehicle transferred in the name of the purchaser with endorsement of Finance Company's hypothecation over the Vehicle in registration certificate of the Vehicle for any reason whatsoever within 60 days of date of loan disbursement by KSOS

Notwithstanding anything contained herein, if at any time it is found that any proposal, application and/or document(s) is submitted negligently or fraudulently or by adoption of any unfair, irregular or illegal means or methods, either in collusion or convenience with the seller or buyer and/or any other person, as the case may be or any way as a result of which KSOS is put to any loss, inconvenience, prejudice and/or detriment, whether directly or indirectly, the Channel Partner shall assume liability and consequences thereof and shall indemnify and compensate KSOS fully in respect of all such losses, inconvenience, prejudice or detriment. The compensation shall be such sum of money as in the opinion of KSOS would be commensurate with the loss etc. suffered by KSOS as a result of such negligence, fraud etc. as the case may be and the same will be paid within 7 (seven) days of notification by KSOS.
`}
            </Text>
          </View>
          {/* Clause 9 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`9.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {`CONFIDENTIALITY   `}
              </Text>
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginLeft: 10,
            }}
          >
            <Text style={[styles.paragraph, { marginLeft: 20 }]}>
              {`Channel Partner agrees to treat the following information as confidential and not to divulge, use or exploit the same except as expressly permitted under this Agreement: (a) the existence and terms of this Agreement; (b) all information received from KSOS under or in connection with this Agreement; (c) Lead Information and personally identifiable information of Lead. The foregoing restrictions shall not apply to the extent the information: (a) ceases to be confidential and enters into the public domain other than due to a breach of this Agreement by the receiving party; (b) is acquired by the receiving party from a third party free of any obligation of confidence, or (c) is required by law to be disclosed.`}
            </Text>
          </View>
          {/* Clause 10 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`10.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {`TERMINATION   `}
              </Text>
            </Text>
          </View>
          {/* Clause 10.1 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`10.1`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              <Text style={styles.bold}>Termination For Cause:</Text>
              {`  Either Party may terminate this Agreement for convenience by giving a prior written notice of 30 days. On expiry of such 30-day period, this Agreement shall automatically stand terminated.`}
            </Text>
          </View>
          {/* Clause 10.2 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`10.2`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              <Text style={styles.bold}>Termination for Convenience:</Text>
              {`Without prejudice to any other rights or remedies available under this Agreement or under law, KSOS at its sole discretion terminate this Agreement forthwith, by providing written notice to Channel Partner, upon or at any time after the happening of any of the following events, namely: (i) if Channel Partner is in breach of any provision of this Agreement, and fails to remedy such breach to the satisfaction of KSOS within 5 days of receipt of written notice from KSOS informing Channel Partner of the breach; or (ii) if Channel Partner either itself or through its representatives commits or permits to be committed any act which, in the reasonable opinion of KSOS, is prejudicial to KSOS or its affiliate's interest or reputation.`}{" "}
            </Text>
          </View>
          {/* Clause 10.3 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`10.3`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              <Text style={styles.bold}>Effects of Termination: </Text>
              {`  Upon the termination of this Agreement: (i) Channel Partner shall not claim any association with KSOS; (ii) Channel Partner shall not use the Intellectual Property of KSOS; (iii) Channel Partner shall not intentionally or otherwise commit any act(s) as would keep a third party to believe that the Channel Partner is still associated with KSOS in terms of this Agreement; and (iv) Channel Partner shall immediately return all documents, data, material belonging to KSOS, which is in possession of Channel Partner.`}
            </Text>
          </View>
          {/* Clause 10.4 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`10.4`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              {`  However, the termination of the Agreement shall not affect any rights or obligations of either Party: (a) accrued before the date of termination; or (b) expressed or intended to continue in force after and despite termination, which shall include obligations pertaining to indemnity and limitation of liability.`}
            </Text>
          </View>
          {/* Clause 11 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text>
              <Text style={{ width: 20 }}>{`11.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {`OWNERSHIP AND USE OF CHANNEL PARTNER’S LOGO   `}
              </Text>
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              // marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              {`  KSOS hereby agrees to grant to the Channel Partner, a limited, non-exclusive, royalty-free, non-sub-licensable, non-assignable, non-transferable, and revocable license to use the KSOS’s name, logo and trademark ("KSOS Logo") during the Term of this Agreement solely for the purposes undertaking its obligations as specified under this Agreement.`}
            </Text>
          </View>
          {/* Clause 12 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text style={{}}>
              <Text style={{ width: 20 }}>{`12.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {`INTELLECTUAL PROPERTY RIGHTS   `}
              </Text>
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              // marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              {`Channel Partner agrees and acknowledges that all rights including all intellectual property rights and/or data/documents/information related to KSOS's product or services including its logo, trademark and its derivative work thereof vests solely with KSOS alone.`}
            </Text>
          </View>
          {/* Clause 13 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text style={{}}>
              <Text style={{ width: 20 }}>{`13.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {`DISCLAIMER & LIMITATION OF LIABILITY   `}
              </Text>
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              // marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              {`EXCEPT AS EXPRESSLY SET FORTH HEREIN, KSOS MAKES NO OTHER WARRANTIES TO THE DELAER OR LEAD AND DISCLAIMS ALL WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE. FURTHER, KSOS DOES NOT, AND FURTHER DOES NOT INTEND TO, INVOLVE ITSLEF INTO SALE/PURCHASE OF VEHICLE. THE SALE/PURCHASE OF VEHICLE IS A BI-PARTITE CONTRACT BETWEEN BUYER AND SELLER OF A PARTICULAR VEHICLE. IT IS EXPRESLLY ACKNOWLEDGED BY THE PARTIES THAT AT NO POINT IN TIME, KSOS IS DEEMED TO BE OWNER OF ANY VEHICLE OR INVENTORY LISTED ON THE PORTAL OR FOR WHICH LOAN APPLICATION HAS BEEN SUBMITTED UNDER THIS AGREEMENT
            
      In no event shall KSOS, its shareholders, directors, officers, employees, agents, affiliates, licensors, or suppliers be liable hereunder for any consequential, exemplary, special, indirect, incidental, or punitive damages or lost revenue, lost profits or anticipates business (even if they have been advised  of possibility of such damages) arising from or relating to this Agreement and the subject matter hereof. The aggregate liability of KSOS, its shareholders, directors, officers, agents, affiliates, and suppliers to Channel Partner for any damages arising out or relating to this Agreement, however caused under any theory of liability, shall not exceed the total Fees paid by KSOS to the Channel Partner during the immediately preceding month during which such claim accrued.`}
            </Text>
          </View>
          {/* Clause 14 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
            }}
          >
            <Text style={{}}>
              <Text style={{ width: 20 }}>{`14.`}</Text>
              <Text
                style={[
                  styles.paragraph,
                  { marginLeft: 9, textDecoration: "underline" },
                ]}
              >
                {`DISCLAIMER & LIMITATION OF LIABILITY   `}
              </Text>
            </Text>
          </View>
          {/* Clause 14.1 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`14.1`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              <Text style={styles.bold}>Independent Contractor: </Text>
              {`  Both the parties shall under all circumstances be treated as an independent Party and nothing contained herein shall be deemed to construe the relationship between the Parties hereto as being a joint venture, partnership, agency, or employment relationship. It is clarified that this Agreement is entered on a principal-to-principal basis. As an independent contractor, the Channel Partner and its employees/ representatives have no authority/right to bind KSOS in any manner and shall not do any act, deed or thing which has the effect of binding KSOS or creating any liability on KSOS otherwise than as specifically provided herein.`}
            </Text>
          </View>
          {/* Clause 14.2 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`14.2`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              <Text style={styles.bold}>Assignment: </Text>
              {`  Channel Partner shall not assign or otherwise transfer its rights or obligations under this Agreement, in whole or in part, without the prior written consent of the KSOS.`}
            </Text>
          </View>
          {/* Clause 14.3 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`14.3`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              <Text style={styles.bold}>Entire Agreement: </Text>
              {`  This Agreement constitutes the entire agreement and understanding of the Parties and supersedes any previous agreement or understanding between the Parties, relating to the subject matter.`}
            </Text>
          </View>
          {/* Clause 14.4 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`14.4`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              <Text style={styles.bold}>Severability: </Text>
              {`  If any provision of herein is or becomes, in whole or in part, invalid or unenforceable but would be valid or enforceable if some part of that provision was deleted, that provision shall apply with such deletions as may be necessary to make it valid.`}
            </Text>
          </View>
          {/* Clause 14.5 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`14.5`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              <Text style={styles.bold}>Governing Law & Jurisdiction: </Text>
              {`  Agreement hereunder shall be governed by and construed in accordance with the laws of India. The competent courts in Mumbai, Pune shall have exclusive jurisdiction over any disputes under this Agreement.`}
            </Text>
          </View>
          {/* Clause 14.6 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`14.6`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              <Text style={styles.bold}>Waiver: </Text>
              {`  No failure or delay in enforcing any right will be deemed a waiver unless made in writing and signed by a duly authorized representative of such Party.`}
            </Text>
          </View>
          {/* Clause 14.7 Header */}
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: 10,
              // marginRight: 10,
            }}
          >
            <Text style={{ width: 20, marginLeft: 0 }}>{`14.7`}</Text>
            <Text
              style={[
                styles.paragraph,
                { flex: 1, marginBottom: 0, marginTop: 0, marginLeft: 9 },
              ]}
            >
              <Text style={styles.bold}>Notices: </Text>
              {`  Any notice under this Agreement shall be in writing and shall be sent at the registered addresses of the Parties as provided by a Party`}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center", // centers child horizontally in row
              marginTop: 10,
              marginLeft: 10,
              marginRight: 10, // if needed
            }}
          >
            <Text style={[styles.bold, { textAlign: "center" }]}>
              Schedule 1 – Facility Letter
            </Text>
          </View>
          {facilityLetter?.rows?.length > 0 ? (
            <View style={styles.table}>
              {/* Table Header */}
              <View style={styles.tableRow}>
                {facilityLetter.headers.map((header, i) => (
                  <View
                    style={[
                      styles.tableCol,
                      {
                        width: header === "Provisions" ? 300 : columnWidths[i],
                      },
                    ]}
                    key={`header-${i}`}
                  >
                    <Text style={[styles.tableCell, { fontWeight: "bold" }]}>
                      {header}
                    </Text>
                  </View>
                ))}
              </View>

              {/* Table Rows */}
              {facilityLetter.rows.map((row, rowIndex) => (
                <View style={styles.tableRow} key={`row-${rowIndex}`}>
                  {row.map((cell, cellIndex) => (
                    <View
                      style={[
                        styles.tableCol,
                        { width: columnWidths[cellIndex] },
                      ]}
                      key={`cell-${rowIndex}-${cellIndex}`}
                    >
                      <Text style={styles.tableCell}>
                        {splitLongWords(cell, 20)}
                      </Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>
          ) : (
            <View></View>
          )}
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center", // centers child horizontally in row
              marginTop: 10,
              marginLeft: 10,
              marginRight: 10, // if needed
            }}
          >
            <Text style={[styles.bold, { textAlign: "center" }]}>
              Schedule 2 - PAYMENT AUTHORIZATION LETTER
            </Text>
          </View>
          <View style={styles.section}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "right",
              }}
            >
              <Text>To,</Text>
              <Text>Date: {newDateFormate}</Text>
            </View>
            <Text>
              {"\nKrishak Sevita Online Solutions Private Limited (KSOS) "}
            </Text>

            <View
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 10,
                fontWeight: "bold",
              }}
            >
              <Text style={{ fontWeight: "bold", color: "black" }}>sub: </Text>
              <Text style={{ fontWeight: "bold", color: "black" }}>
                Authorization of making payment in favour of (Name of the Dealer
                and Customer)
              </Text>
            </View>
            <Text style={{ marginTop: 10 }}>Dear Sir,</Text>

            <Text style={{ marginTop: 10 }}>{content}</Text>

            <View
              style={{
                flexDirection: "row",
                marginTop: 10,
                marginLeft: -2,
              }}
            >
              <Text style={styles.paragraph}>Vehicle Details:</Text>
            </View>

            <View style={[styles.table, { marginTop: -5 }]}>
              {VehicleDetails.rows.map((row, rowIndex) => (
                <View style={styles.tableRow} key={`row-${rowIndex}`}>
                  {row.map((cell, cellIndex) => (
                    <View
                      key={`cell-${rowIndex}-${cellIndex}`}
                      style={[
                        styles.tableCol,
                        { width: columnWidth[cellIndex] },
                      ]}
                    >
                      <Text style={styles.tableCell}>{cell}</Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>

            <View
              style={{
                flexDirection: "row",
                marginTop: 10,
                marginLeft: -2,
              }}
            >
              <Text style={styles.paragraph}>Bifurcation of Loan Amount:</Text>
            </View>

            <View style={[styles.table, { marginTop: -5 }]}>
              {/* Table Rows */}
              {BifurcationofLoanAmount.rows.map((row, rowIndex) => (
                <View style={styles.tableRow} key={`row-${rowIndex}`}>
                  {row.map((cell, cellIndex) => (
                    <View
                      key={`cell-${rowIndex}-${cellIndex}`}
                      style={[
                        styles.tableCol,
                        { width: columnWidthss[cellIndex] },
                      ]}
                    >
                      <Text style={styles.tableCell}>{cell}</Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>

            <View
              style={{
                flexDirection: "row",
                marginTop: 10,
                marginLeft: -2,
              }}
            >
              <Text style={[styles.paragraph, { flex: 1, marginTop: 10 }]}>
                {assuranceText}
              </Text>
            </View>
            <View style={[styles.table, { marginTop: -12 }]}>
              {DealerBankDetails.rows.map((row, rowIndex) => (
                <View style={styles.tableRow} key={`row-${rowIndex}`}>
                  {row.map((cell, cellIndex) => (
                    <View
                      key={`cell-${rowIndex}-${cellIndex}`}
                      style={[
                        styles.tableCol,
                        { width: columnWidthssss[cellIndex] },
                      ]}
                    >
                      <Text style={styles.tableCell}>{cell}</Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>
            <View
              style={{
                flexDirection: "row",
                marginTop: 10,
                marginLeft: -2,
              }}
            >
              <Text style={[styles.paragraph, { flex: 1, marginTop: 10 }]}>
                {`(Name of the Borrower) Account Details:`}
              </Text>
            </View>

            <View style={[styles.table, { marginTop: -12 }]}>
              {BorrowerBankDetails.rows.map((row, rowIndex) => (
                <View style={styles.tableRow} key={`row-${rowIndex}`}>
                  {row.map((cell, cellIndex) => (
                    <View
                      key={`cell-${rowIndex}-${cellIndex}`}
                      style={[
                        styles.tableCol,
                        { width: columnWidthssss[cellIndex] },
                      ]}
                    >
                      <Text style={styles.tableCell}>{cell}</Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>
            <View style={{ flexDirection: "row", marginTop: 10 }}>
              <Text style={{ fontWeight: "bold", color: "black" }}>
                Thanking you.{" "}
              </Text>
            </View>

            <View style={{ flexDirection: "row" }}>
              <Text style={{ fontWeight: "bold", color: "black" }}>
                Yours Truly,
              </Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center", // centers child horizontally in row
              marginTop: 10,
              marginLeft: 10,
              marginRight: 10, // if needed
            }}
          >
            <Text style={[styles.bold, { textAlign: "center" }]}>
              Schedule 3 – General Details
            </Text>
          </View>
          {GeneralDetails?.rows?.length > 0 ? (
            <View style={styles.table}>
              {/* Table Header */}
              <View style={styles.tableRow}>
                {GeneralDetails.headers.map((header, i) => (
                  <View
                    key={`header-${i}`}
                    style={[styles.tableCol, { width: columnWidths[i] }]}
                  >
                    <Text style={[styles.tableCell, { fontWeight: "bold" }]}>
                      {header}
                    </Text>
                  </View>
                ))}
              </View>

              {/* Table Rows */}
              {GeneralDetails.rows.map((row, rowIndex) => (
                <View style={styles.tableRow} key={`row-${rowIndex}`}>
                  {row.map((cell, cellIndex) => (
                    <View
                      key={`cell-${rowIndex}-${cellIndex}`}
                      style={[
                        styles.tableCol,
                        { width: columnWidths[cellIndex], padding: 4 },
                      ]}
                    >
                      {/* Checking for nested details for row 6, which is about the Channel Dealer */}
                      {rowIndex === 5 && cellIndex === 2 ? ( // 6th row, "Particulars / Details"
                        <View>
                          {/* Display the main details of Channel Dealer */}
                          {row.map((header, i) => (
                            <>
                              {header?.parties?.map((val, key, index) => (
                                <>
                                  <Text
                                    style={{
                                      fontWeight: "bold",
                                      marginBottom: 4,
                                    }}
                                  >
                                    {val?.title}
                                  </Text>
                                  {val?.values.map((row, rowIndex) => (
                                    <View
                                      style={styles.tableRow}
                                      key={`row-${rowIndex}`}
                                    >
                                      {row.map((cell, cellIndex) => (
                                        <View
                                          key={`cell-${rowIndex}-${cellIndex}`}
                                          style={[
                                            styles.tableCol,
                                            {
                                              width:
                                                columnWidthNoticeClause[
                                                cellIndex
                                                ],
                                            },
                                          ]}
                                        >
                                          <Text style={styles.tableCell}>
                                            {cell}
                                          </Text>
                                        </View>
                                      ))}
                                    </View>
                                  ))}
                                </>
                              ))}
                            </>
                          ))}
                        </View>
                      ) : (
                        <Text style={styles.tableCell}>
                          {splitLongWords(String(cell), 20)}{" "}
                          {/* Ensures long text is split into readable chunks */}
                        </Text>
                      )}
                    </View>
                  ))}
                </View>
              ))}
            </View>
          ) : (
            <View />
          )}
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center", // centers child horizontally in row
              marginTop: 10,
              marginLeft: 10,
              marginRight: 10, // if needed
            }}
          >
            <Text style={[styles.bold, { textAlign: "center" }]}>
              Schedule 4 – Credit Request Letter
            </Text>
          </View>
          <View style={styles.section}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "right",
              }}
            >
              <Text>To,</Text>
              {/* <Text>Date: {newDateFormate}</Text> */}
            </View>
            <Text>{"\nKrishak Sevita Online Solutions Private Limited "}</Text>

            <Text style={{ marginTop: 10 }}>Dear Sir,</Text>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 10,
                fontWeight: "bold",
              }}
            >
              <Text style={{ fontWeight: "bold", color: "black" }}>
                This is with reference to Clause 3.2.2 of the Agreement dated
                _____________, executed between ______________ (as Channel
                Partner) and Krishak Sevita Online Solutions Private Limited
                (KSOS).
              </Text>
            </View>
            <View
              style={{
                flexDirection: "row",
                marginTop: 10,
                marginLeft: -2,
              }}
            >
              <Text style={styles.paragraph}>
                Details of short-term credit Loan Facility:
              </Text>
            </View>

            <View style={[styles.table, { marginTop: -5 }]}>
              {ShortTermCreditLoan.rows.map((row, rowIndex) => (
                <View style={styles.tableRow} key={`row-${rowIndex}`}>
                  {row.map((cell, cellIndex) => (
                    <View
                      key={`cell-${rowIndex}-${cellIndex}`}
                      style={[
                        styles.tableCol,
                        { width: columnWidthNoticeClause[cellIndex] },
                      ]}
                    >
                      <Text style={styles.tableCell}>{cell}</Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>

            <View
              style={{
                flexDirection: "row",
                marginTop: 10,
                marginLeft: -2,
              }}
            >
              <Text style={styles.paragraph}>
                I/We request you to kindly provide us short-term credit of the
                amount of INR _______/- (Indian Rupees ________________ only) as
                per below calculation:
              </Text>
            </View>

            <View style={[styles.table, { marginTop: -5 }]}>
              {/* Table Rows */}
              {LoanCalculation.rows.map((row, rowIndex) => (
                <View style={styles.tableRow} key={`row-${rowIndex}`}>
                  {row.map((cell, cellIndex) => (
                    <View
                      key={`cell-${rowIndex}-${cellIndex}`}
                      style={[
                        styles.tableCol,
                        { width: columnWidthNoticeClause[cellIndex] },
                      ]}
                    >
                      <Text style={styles.tableCell}>{cell}</Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>

            <View
              style={{
                flexDirection: "row",
                marginTop: 10,
                marginLeft: -2,
              }}
            >
              <Text style={styles.paragraph}>
                I/We request KSOS to transfer INR ____________/- (Rupees _______
                Lacs) into the account, details of which are provided below:
              </Text>
            </View>

            <View style={[styles.table, { marginTop: -12 }]}>
              {TransferLoanAmount.rows.map((row, rowIndex) => (
                <View style={styles.tableRow} key={`row-${rowIndex}`}>
                  {row.map((cell, cellIndex) => (
                    <View
                      key={`cell-${rowIndex}-${cellIndex}`}
                      style={[
                        styles.tableCol,
                        { width: columnWidthNoticeClause[cellIndex] },
                      ]}
                    >
                      <Text style={styles.tableCell}>{cell}</Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>
            <View
              style={{
                flexDirection: "row",
                marginTop: 50,
                marginLeft: -2,
              }}
            >
              <Text style={[styles.paragraph, { flex: 1, marginTop: 10 }]}>
                {`We hereby confirm that we are asking credit to purchase below mentioned vehicle from the Platform:`}
              </Text>
            </View>

            <View style={[styles.table, { marginTop: -12 }]}>
              {ConformationCreditAskingTable.rows.map((row, rowIndex) => (
                <View style={styles.tableRow} key={`row-${rowIndex}`}>
                  {row.map((cell, cellIndex) => (
                    <View
                      key={`cell-${rowIndex}-${cellIndex}`}
                      style={[
                        styles.tableCol,
                        { width: columnWidthNoticeClause[cellIndex] },
                      ]}
                    >
                      <Text style={styles.tableCell}>{cell}</Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>
            <View
              style={{
                flexDirection: "row",
                marginTop: 10,
                marginLeft: -2,
              }}
            >
              <Text style={[styles.paragraph, { flex: 1, marginTop: 10 }]}>
                {`We hereby confirm that we have complied with the provisions of the Agreement which are required to be complied with prior to the request of credit. Capitalized terms not defined herein shall have the meaning assigned to such terms under the Channel Finance Agreement.`}
              </Text>
            </View>
            <View style={{ flexDirection: "row", marginTop: 10 }}>
              <Text style={{ fontWeight: "bold", color: "black" }}>
                Thanks and regards,
              </Text>
            </View>

            <View style={{ flexDirection: "row" }}>
              <Text style={{ fontWeight: "bold", color: "black" }}>
                Authorized Signatory
              </Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center", // centers child horizontally in row
              marginTop: 10,
              marginLeft: 10,
              marginRight: 10, // if needed
            }}
          >
            <Text style={[styles.bold, { textAlign: "center" }]}>
              Annexure A – Fee
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 10,
              marginLeft: -2,
            }}
          >
            <Text style={styles.paragraph}>
              KSOS agrees to pay the Channel Partner below mentioned Fees:
            </Text>
          </View>
          <View style={[styles.table, { marginTop: -12 }]}>
            {annexureAFee.rows.map((row, rowIndex) => (
              <View style={styles.tableRow} key={`row-${rowIndex}`}>
                {row.map((cell, cellIndex) => (
                  <View
                    key={`cell-${rowIndex}-${cellIndex}`}
                    style={[
                      styles.tableCol,
                      { width: columnWidthNoticeClause[cellIndex] },
                    ]}
                  >
                    <Text style={styles.tableCell}>{cell}</Text>
                  </View>
                ))}
              </View>
            ))}
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center", // centers child horizontally in row
              marginTop: 10,
              marginLeft: 10,
              marginRight: 10, // if needed
            }}
          >
            <Text style={[styles.bold, { textAlign: "center" }]}>
              Annexure B – Post Dated Cheque
            </Text>
          </View>
          {postDatedCheque?.rows?.length > 0 ? (
            <View style={styles.table}>
              {/* Table Header */}
              <View style={styles.tableRow}>
                {postDatedCheque.headers.map((header, i) => (
                  <View
                    style={[
                      styles.tableCol,
                      {
                        width:
                          header === "Provisions" ? 300 : columnWidthsss[i],
                      },
                    ]}
                    key={`header-${i}`}
                  >
                    <Text style={[styles.tableCell, { fontWeight: "bold" }]}>
                      {header}
                    </Text>
                  </View>
                ))}
              </View>

              {/* Table Rows */}
              {postDatedCheque.rows.map((row, rowIndex) => (
                <View style={styles.tableRow} key={`row-${rowIndex}`}>
                  {row.map((cell, cellIndex) => (
                    <View
                      style={[
                        styles.tableCol,
                        { width: columnWidthsss[cellIndex] },
                      ]}
                      key={`cell-${rowIndex}-${cellIndex}`}
                    >
                      <Text style={styles.tableCell}>
                        {splitLongWords(cell, 20)}
                      </Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>
          ) : (
            <View></View>
          )}
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center", // centers child horizontally in row
              marginTop: 10,
              marginLeft: 10,
              marginRight: 10, // if needed
            }}
          >
            <Text style={[styles.bold, { textAlign: "center" }]}>
              Annexure C – KSOS Bank Account Details
            </Text>
          </View>
          <View style={[styles.table, { marginTop: 12 }]}>
            {AnnexureCKSOSBankAccountDetails.rows.map((row, rowIndex) => (
              <View style={styles.tableRow} key={`row-${rowIndex}`}>
                {row.map((cell, cellIndex) => (
                  <View
                    key={`cell-${rowIndex}-${cellIndex}`}
                    style={[
                      styles.tableCol,
                      { width: columnWidthNoticeClause[cellIndex] },
                    ]}
                  >
                    <Text style={styles.tableCell}>{cell}</Text>
                  </View>
                ))}
              </View>
            ))}
          </View>
          <View style={[styles.footer, { marginTop: 10 }]} fixed>
            <Text>
              {` BUSINESS ALLIANCE AGREEMENT – ${KSOSID} –`}
              {formData?.businessType === "individual" ? (
                <Text style={styles.footerBold}>
                  {`(${name})`}
                </Text>
              ) : formData?.businessType === "partnership" ? (
                <Text style={styles.footerBold}>
                  {` ${furmName}`}
                </Text>
              ) : (
                <Text style={styles.footerBold}>
                  {` ${furmName} (${name})`}
                </Text>
              )}
            </Text>
            <Text
              style={styles.pageNumber}
              render={({ pageNumber, totalPages }) =>
                `${pageNumber} / ${totalPages}`
              }
              fixed
            />
          </View>
        </Page>
        )}
        {part !== "mtbl" && (formData?.businessType === "partnership" ? (
          formData?.otherDetails?.partners?.map((partner, index) => (
            <Page size="A4" style={styles.page}>
              <View style={styles.section}>
                <Text style={styles.heading}>{heading}</Text>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    textAlign: "right",
                  }}
                >
                  <Text> </Text>
                </View>
                <Text>
                  {
                    isTAFundingByMt
                      ? "To, \nThe Manager\nKrishak Sevita Online Solutions Private Limited (KSOS)"
                      : "To, \nThe Branch Manage\nTyger Capital Pvt. Ltd (TCPL) (Formerly Known as Adani Capital Pvt Ltd)"
                  }
                </Text>
                <Text style={{ marginTop: 10 }}>Dear Sir/Madam,</Text>
                <Text style={{ marginTop: 5 }}>
                  Opening of {isTAFundingByMt ? "auction ID with Krishak Sevita Online Solutions Private Limited (KSOS) Pune" : "Loan account with Tyger Capital Pvt. Ltd (TCPL) Mumbai Branch"}
                </Text>
                {/* <Text>{contents}</Text> */}
                <View style={{ flexDirection: "row", marginTop: 10 }}>
                  {formData?.businessType === "individual" ? (
                    <Text style={[styles.paragraph, { flex: 1 }]}>
                      {`I/We hereby voluntarily submit my/our Aadhaar number, Virtual ID, e-Aadhaar, XML, Masked Aadhaar, Aadhaar details, demographic information, information obtained through face authentication and/or biometric information ("Information"). I/We confirm that: `}

                      <Text style={styles.bold}>{name}</Text>
                      {`

a)I/We have been given other alternative means by ${isTAFundingByMt ? "KSOS" : "TCPL"} for KYC purposes including physical KYC by submitting officially valid documents and I/We have voluntarily chosen Aadhaar based KYC.

b)    I/We am/are aware that my/our Information can be used only for any of the following purposes and not for any other purpose:

i.   for requirements as per KYC norms, PML Act, 2002 and rules thereunder and RBI/NHB guidelines;
ii.  for any other facility related to banking operations and services'
iii. for carrying out authentication, using e-KYC or Yes/No authentication facility or any other mode or facility as may be permitted from time to time under the applicable law;
iv.  for the purpose of availing the any Govt. subsidy, if any.

c)    I/We hereby authorize and consent to ${isTAFundingByMt ? "KSOS" : "TCPL"} to collect, disclose, share, store, preserve and use the Information and authentication data and records, as may be required under the applicable law or for the purposes above or as per the internal requirements of ${isTAFundingByMt ? "KSOS" : "TCPL"}. I have been explained in local language about the consent, purpose of collecting Aadhaar and the nature of information that may be shared upon authentication.

d)    I/We confirm that the Information shared are correct and pertain to me and I/We shall not hold ${isTAFundingByMt ? "KSOS" : "TCPL"} or any of its officials responsible in case of any incorrect information provided by me/us.

e)     I/We authorize the ${isTAFundingByMt ? "KSOS" : "TCPL"} to enable the my/our account for Aadhaar enabled Payment Services (ASPS) transaction services.
f)     I/We confirm that I/We have downloaded the e-Aadhaar myself/ourselves by using the OTP received on my/our Aadhaar registered mobile number and, I/We voluntarily submit the same to the ${isTAFundingByMt ? "KSOS" : "TCPL"} to consider it as my KYC document. I/We will not hold the ${isTAFundingByMt ? "KSOS" : "TCPL"} or its officials responsible in the event this document is not found to be in order.
`}
                    </Text>
                  ) : (
                    <Text style={[styles.paragraph, { flex: 1 }]}>
                      {`I/We hereby voluntarily submit my/our Aadhaar number, Virtual ID, e-Aadhaar, XML, Masked Aadhaar, Aadhaar details, demographic information, information obtained through face authentication and/or biometric information ("Information"). I/We confirm that: `}
                      <Text style={styles.bold}>{partner}</Text>
                      {/* {` (Prop: `}
                      <Text style={styles.bold}>{name}</Text>
                      {`). */}
                      {`.

a)I/We have been given other alternative means by ${isTAFundingByMt ? "KSOS" : "TCPL"} for KYC purposes including physical KYC by submitting officially valid documents and I/We have voluntarily chosen Aadhaar based KYC.

b)    I/We am/are aware that my/our Information can be used only for any of the following purposes and not for any other purpose:

i.   for requirements as per KYC norms, PML Act, 2002 and rules thereunder and RBI/NHB guidelines;
ii.  for any other facility related to banking operations and services'
iii. for carrying out authentication, using e-KYC or Yes/No authentication facility or any other mode or facility as may be permitted from time to time under the applicable law;
iv.  for the purpose of availing the any Govt. subsidy, if any.

c)    I/We hereby authorize and consent to ${isTAFundingByMt ? "KSOS" : "TCPL"} to collect, disclose, share, store, preserve and use the Information and authentication data and records, as may be required under the applicable law or for the purposes above or as per the internal requirements of ${isTAFundingByMt ? "KSOS" : "TCPL"}. I have been explained in local language about the consent, purpose of collecting Aadhaar and the nature of information that may be shared upon authentication.

d)    I/We confirm that the Information shared are correct and pertain to me and I/We shall not hold ${isTAFundingByMt ? "KSOS" : "TCPL"} or any of its officials responsible in case of any incorrect information provided by me/us.

e)     I/We authorize the ${isTAFundingByMt ? "KSOS" : "TCPL"} to enable the my/our account for Aadhaar enabled Payment Services (ASPS) transaction services.
f)     I/We confirm that I/We have downloaded the e-Aadhaar myself/ourselves by using the OTP received on my/our Aadhaar registered mobile number and, I/We voluntarily submit the same to the ${isTAFundingByMt ? "KSOS" : "TCPL"} to consider it as my KYC document. I/We will not hold the ${isTAFundingByMt ? "KSOS" : "TCPL"} or its officials responsible in the event this document is not found to be in order.
`}
                    </Text>
                  )}
                </View>
                <View style={{ flexDirection: "col" }}>
                  <Text>Name & Signature,</Text>
                  <Text>(Applicant/Co-Applicant/Guarantor)</Text>
                </View>
              </View>
            </Page>))) : (
          <Page size="A4" style={styles.page}>
            <View style={styles.section}>
              <Text style={styles.heading}>{heading}</Text>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  textAlign: "right",
                }}
              >
                <Text> </Text>
              </View>
              <Text>
                {
                  isTAFundingByMt
                    ? "To, \nThe Manager\nKrishak Sevita Online Solutions Private Limited (KSOS)"
                    : "To, \nThe Branch Manage\nTyger Capital Pvt. Ltd (TCPL) (Formerly Known as Adani Capital Pvt Ltd)"
                }
              </Text>
              <Text style={{ marginTop: 10 }}>Dear Sir/Madam,</Text>
              <Text style={{ marginTop: 5 }}>
                Opening of {isTAFundingByMt ? "auction ID with Krishak Sevita Online Solutions Private Limited (KSOS) Pune" : "Loan account with Tyger Capital Pvt. Ltd (TCPL) Mumbai Branch"}
              </Text>
              {/* <Text>{contents}</Text> */}
              <View style={{ flexDirection: "row", marginTop: 10 }}>
                {formData?.businessType === "individual" ? (
                  <Text style={[styles.paragraph, { flex: 1 }]}>
                    {`I/We hereby voluntarily submit my/our Aadhaar number, Virtual ID, e-Aadhaar, XML, Masked Aadhaar, Aadhaar details, demographic information, information obtained through face authentication and/or biometric information ("Information"). I/We confirm that: `}

                    <Text style={styles.bold}>{name}</Text>
                    {`

a)I/We have been given other alternative means by ${isTAFundingByMt ? "KSOS" : "TCPL"} for KYC purposes including physical KYC by submitting officially valid documents and I/We have voluntarily chosen Aadhaar based KYC.

b)    I/We am/are aware that my/our Information can be used only for any of the following purposes and not for any other purpose:

i.   for requirements as per KYC norms, PML Act, 2002 and rules thereunder and RBI/NHB guidelines;
ii.  for any other facility related to banking operations and services'
iii. for carrying out authentication, using e-KYC or Yes/No authentication facility or any other mode or facility as may be permitted from time to time under the applicable law;
iv.  for the purpose of availing the any Govt. subsidy, if any.

c)    I/We hereby authorize and consent to ${isTAFundingByMt ? "KSOS" : "TCPL"} to collect, disclose, share, store, preserve and use the Information and authentication data and records, as may be required under the applicable law or for the purposes above or as per the internal requirements of ${isTAFundingByMt ? "KSOS" : "TCPL"}. I have been explained in local language about the consent, purpose of collecting Aadhaar and the nature of information that may be shared upon authentication.

d)    I/We confirm that the Information shared are correct and pertain to me and I/We shall not hold ${isTAFundingByMt ? "KSOS" : "TCPL"} or any of its officials responsible in case of any incorrect information provided by me/us.

e)     I/We authorize the ${isTAFundingByMt ? "KSOS" : "TCPL"} to enable the my/our account for Aadhaar enabled Payment Services (ASPS) transaction services.
f)     I/We confirm that I/We have downloaded the e-Aadhaar myself/ourselves by using the OTP received on my/our Aadhaar registered mobile number and, I/We voluntarily submit the same to the ${isTAFundingByMt ? "KSOS" : "TCPL"} to consider it as my KYC document. I/We will not hold the ${isTAFundingByMt ? "KSOS" : "TCPL"} or its officials responsible in the event this document is not found to be in order.
`}
                  </Text>
                ) : (
                  <Text style={[styles.paragraph, { flex: 1 }]}>
                    {`I/We hereby voluntarily submit my/our Aadhaar number, Virtual ID, e-Aadhaar, XML, Masked Aadhaar, Aadhaar details, demographic information, information obtained through face authentication and/or biometric information ("Information"). I/We confirm that: `}
                    <Text style={styles.bold}>{companyName}</Text>
                    {` (Prop: `}
                    <Text style={styles.bold}>{name}</Text>
                    {`).

a)I/We have been given other alternative means by ${isTAFundingByMt ? "KSOS" : "TCPL"} for KYC purposes including physical KYC by submitting officially valid documents and I/We have voluntarily chosen Aadhaar based KYC.

b)    I/We am/are aware that my/our Information can be used only for any of the following purposes and not for any other purpose:

i.   for requirements as per KYC norms, PML Act, 2002 and rules thereunder and RBI/NHB guidelines;
ii.  for any other facility related to banking operations and services'
iii. for carrying out authentication, using e-KYC or Yes/No authentication facility or any other mode or facility as may be permitted from time to time under the applicable law;
iv.  for the purpose of availing the any Govt. subsidy, if any.

c)    I/We hereby authorize and consent to ${isTAFundingByMt ? "KSOS" : "TCPL"} to collect, disclose, share, store, preserve and use the Information and authentication data and records, as may be required under the applicable law or for the purposes above or as per the internal requirements of ${isTAFundingByMt ? "KSOS" : "TCPL"}. I have been explained in local language about the consent, purpose of collecting Aadhaar and the nature of information that may be shared upon authentication.

d)    I/We confirm that the Information shared are correct and pertain to me and I/We shall not hold ${isTAFundingByMt ? "KSOS" : "TCPL"} or any of its officials responsible in case of any incorrect information provided by me/us.

e)     I/We authorize the ${isTAFundingByMt ? "KSOS" : "TCPL"} to enable the my/our account for Aadhaar enabled Payment Services (ASPS) transaction services.
f)     I/We confirm that I/We have downloaded the e-Aadhaar myself/ourselves by using the OTP received on my/our Aadhaar registered mobile number and, I/We voluntarily submit the same to the ${isTAFundingByMt ? "KSOS" : "TCPL"} to consider it as my KYC document. I/We will not hold the ${isTAFundingByMt ? "KSOS" : "TCPL"} or its officials responsible in the event this document is not found to be in order.
`}
                  </Text>
                )}
              </View>
              <View style={{ flexDirection: "col" }}>
                <Text>Name & Signature,</Text>
                <Text>(Applicant/Co-Applicant/Guarantor)</Text>
              </View>
            </View>
          </Page>
        ))}
      </Document>
    </>
  );
};

export default AadharConcentandMTBLAggrementDocumentPDF;
